// This file is auto-generated by @hey-api/openapi-ts

import { bambiApi as coreApi } from '../internal/api.ts';
import { fileResponseHandler } from '../internal/fileResponse.ts';
import {
  type AttendantsListApiArg,
  type AttendantsListApiResponse,
  type AttendantsCreateApiArg,
  type AttendantsCreateApiResponse,
  type AttendantsDestroyApiArg,
  type AttendantsDestroyApiResponse,
  type AttendantsRetrieveApiArg,
  type AttendantsRetrieveApiResponse,
  type AttendantsPartialUpdateApiArg,
  type AttendantsPartialUpdateApiResponse,
  type AttendantsSkillsCreateApiArg,
  type AttendantsSkillsCreateApiResponse,
  type AttendantsSkillsDestroyApiArg,
  type AttendantsSkillsDestroyApiResponse,
  type AttendantsSkillsRetrieveApiArg,
  type AttendantsSkillsRetrieveApiResponse,
  type AttendantsSkillsPartialUpdateApiArg,
  type AttendantsSkillsPartialUpdateApiResponse,
  type AttendantsSkillsUpdateApiArg,
  type AttendantsSkillsUpdateApiResponse,
  type BillingBillingSettingsRetrieveApiArg,
  type BillingBillingSettingsRetrieveApiResponse,
  type BillingBillingSettingsPartialUpdateApiArg,
  type BillingBillingSettingsPartialUpdateApiResponse,
  type BillingBillingSettingsNextInvoiceNumberRetrieveApiArg,
  type BillingBillingSettingsNextInvoiceNumberRetrieveApiResponse,
  type BillingTripsBillingListApiArg,
  type BillingTripsBillingListApiResponse,
  type BrokersAliviAdminListApiArg,
  type BrokersAliviAdminListApiResponse,
  type BrokersAliviAdminCreateApiArg,
  type BrokersAliviAdminCreateApiResponse,
  type BrokersAliviOauth2TokenCreateApiArg,
  type BrokersAliviOauth2TokenCreateApiResponse,
  type BrokersAliviRideActivateWillcallCreateApiArg,
  type BrokersAliviRideActivateWillcallCreateApiResponse,
  type BrokersAliviRideCancelCreateApiArg,
  type BrokersAliviRideCancelCreateApiResponse,
  type BrokersAliviRideCancelWillcallActivationCreateApiArg,
  type BrokersAliviRideCancelWillcallActivationCreateApiResponse,
  type BrokersAliviRideGetStatusCreateApiArg,
  type BrokersAliviRideGetStatusCreateApiResponse,
  type BrokersAliviRideOfferCreateApiArg,
  type BrokersAliviRideOfferCreateApiResponse,
  type BrokersAliviRideUpdateCreateApiArg,
  type BrokersAliviRideUpdateCreateApiResponse,
  type BrokersClearviewOauth2TokenCreateApiArg,
  type BrokersClearviewOauth2TokenCreateApiResponse,
  type BrokersClearviewTransportPayerListApiArg,
  type BrokersClearviewTransportPayerListApiResponse,
  type BrokersClearviewTransportPayerCreateApiArg,
  type BrokersClearviewTransportPayerCreateApiResponse,
  type BrokersClearviewTransportProviderListApiArg,
  type BrokersClearviewTransportProviderListApiResponse,
  type BrokersClearviewTransportProviderCreateApiArg,
  type BrokersClearviewTransportProviderCreateApiResponse,
  type BrokersClearviewTripsListApiArg,
  type BrokersClearviewTripsListApiResponse,
  type BrokersClearviewTripsCreateApiArg,
  type BrokersClearviewTripsCreateApiResponse,
  type BrokersClearviewTripsRetrieveApiArg,
  type BrokersClearviewTripsRetrieveApiResponse,
  type BrokersClearviewTripsPartialUpdateApiArg,
  type BrokersClearviewTripsPartialUpdateApiResponse,
  type BrokersClearviewTripsCancelCreateApiArg,
  type BrokersClearviewTripsCancelCreateApiResponse,
  type BrokersCtcOauth2TokenCreateApiArg,
  type BrokersCtcOauth2TokenCreateApiResponse,
  type BrokersCtcTripCreateApiArg,
  type BrokersCtcTripCreateApiResponse,
  type BrokersCtcTripRetrieveApiArg,
  type BrokersCtcTripRetrieveApiResponse,
  type BrokersCtcTripActivationCreateApiArg,
  type BrokersCtcTripActivationCreateApiResponse,
  type BrokersCtcTripCancelCreateApiArg,
  type BrokersCtcTripCancelCreateApiResponse,
  type BrokersCtcTripsListApiArg,
  type BrokersCtcTripsListApiResponse,
  type BrokersExampleHelloWorldRetrieveApiArg,
  type BrokersExampleHelloWorldRetrieveApiResponse,
  type BrokersKinetikAdminListApiArg,
  type BrokersKinetikAdminListApiResponse,
  type BrokersKinetikAdminCreateApiArg,
  type BrokersKinetikAdminCreateApiResponse,
  type BrokersKinetikOauth2TokenCreateApiArg,
  type BrokersKinetikOauth2TokenCreateApiResponse,
  type BrokersKinetikV1CancelRideCreateApiArg,
  type BrokersKinetikV1CancelRideCreateApiResponse,
  type BrokersKinetikV1CreateRidesCreateApiArg,
  type BrokersKinetikV1CreateRidesCreateApiResponse,
  type BrokersKinetikV1GetDriverCreateApiArg,
  type BrokersKinetikV1GetDriverCreateApiResponse,
  type BrokersKinetikV1GetRideCreateApiArg,
  type BrokersKinetikV1GetRideCreateApiResponse,
  type BrokersKinetikV1GetVehicleCreateApiArg,
  type BrokersKinetikV1GetVehicleCreateApiResponse,
  type BrokersKinetikV1UpdateRidesUpdateApiArg,
  type BrokersKinetikV1UpdateRidesUpdateApiResponse,
  type BrokersLogsSearchRetrieveApiArg,
  type BrokersLogsSearchRetrieveApiResponse,
  type BrokersMedidriveWebhooksCreateApiArg,
  type BrokersMedidriveWebhooksCreateApiResponse,
  type BrokersModivcareRideCreateApiArg,
  type BrokersModivcareRideCreateApiResponse,
  type BrokersModivcareRideUpdateApiArg,
  type BrokersModivcareRideUpdateApiResponse,
  type BrokersModivcareRideCancelCreateApiArg,
  type BrokersModivcareRideCancelCreateApiResponse,
  type BrokersModivcareRideEventsRetrieveApiArg,
  type BrokersModivcareRideEventsRetrieveApiResponse,
  type BrokersModivcareAdminListApiArg,
  type BrokersModivcareAdminListApiResponse,
  type BrokersModivcareAdminCreateApiArg,
  type BrokersModivcareAdminCreateApiResponse,
  type BrokersModivcareAdminBackfillCreateApiArg,
  type BrokersModivcareAdminBackfillCreateApiResponse,
  type BrokersModivcareAdminBillableTripsListApiArg,
  type BrokersModivcareAdminBillableTripsListApiResponse,
  type BrokersModivcareAdminDriversListApiArg,
  type BrokersModivcareAdminDriversListApiResponse,
  type BrokersModivcareAdminRideReceiptCreateApiArg,
  type BrokersModivcareAdminRideReceiptCreateApiResponse,
  type BrokersModivcareOauth2TokenCreateApiArg,
  type BrokersModivcareOauth2TokenCreateApiResponse,
  type BrokersMomentmBrokerAuthListApiArg,
  type BrokersMomentmBrokerAuthListApiResponse,
  type BrokersMomentmBrokerAuthCreateApiArg,
  type BrokersMomentmBrokerAuthCreateApiResponse,
  type BrokersMomentmBrokerAuthDestroyApiArg,
  type BrokersMomentmBrokerAuthDestroyApiResponse,
  type BrokersMomentmBrokerAuthRetrieveApiArg,
  type BrokersMomentmBrokerAuthRetrieveApiResponse,
  type BrokersMomentmBrokerAuthPartialUpdateApiArg,
  type BrokersMomentmBrokerAuthPartialUpdateApiResponse,
  type BrokersMomentmBrokerAuthUpdateApiArg,
  type BrokersMomentmBrokerAuthUpdateApiResponse,
  type BrokersMomentmBrokerAuthSetSecretCreateApiArg,
  type BrokersMomentmBrokerAuthSetSecretCreateApiResponse,
  type BrokersMomentmSetSecretCreateApiArg,
  type BrokersMomentmSetSecretCreateApiResponse,
  type BrokersMoviWebhookCreateApiArg,
  type BrokersMoviWebhookCreateApiResponse,
  type BrokersMtmInitCreateApiArg,
  type BrokersMtmInitCreateApiResponse,
  type BrokersMtmOauth2TokenCreateApiArg,
  type BrokersMtmOauth2TokenCreateApiResponse,
  type BrokersMtmSetSecretCreateApiArg,
  type BrokersMtmSetSecretCreateApiResponse,
  type BrokersMtmTransportationProvidersListApiArg,
  type BrokersMtmTransportationProvidersListApiResponse,
  type BrokersMtmTransportationProvidersCreateApiArg,
  type BrokersMtmTransportationProvidersCreateApiResponse,
  type BrokersMtmTransportationProvidersDestroyApiArg,
  type BrokersMtmTransportationProvidersDestroyApiResponse,
  type BrokersMtmTransportationProvidersRetrieveApiArg,
  type BrokersMtmTransportationProvidersRetrieveApiResponse,
  type BrokersMtmTransportationProvidersPartialUpdateApiArg,
  type BrokersMtmTransportationProvidersPartialUpdateApiResponse,
  type BrokersMtmTransportationProvidersUpdateApiArg,
  type BrokersMtmTransportationProvidersUpdateApiResponse,
  type BrokersMtmTransportationProvidersBackfillTripsCreateApiArg,
  type BrokersMtmTransportationProvidersBackfillTripsCreateApiResponse,
  type BrokersMtmTransportationProvidersGetEmailRetrieveApiArg,
  type BrokersMtmTransportationProvidersGetEmailRetrieveApiResponse,
  type BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiArg,
  type BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiResponse,
  type BrokersMtmTransportationProvidersBackfillRunsListApiArg,
  type BrokersMtmTransportationProvidersBackfillRunsListApiResponse,
  type BrokersMtmTransportationProvidersGetEmailTextRetrieveApiArg,
  type BrokersMtmTransportationProvidersGetEmailTextRetrieveApiResponse,
  type BrokersMtmTransportationProvidersInitCreateApiArg,
  type BrokersMtmTransportationProvidersInitCreateApiResponse,
  type BrokersMtmTransportationProvidersSetSecretCreateApiArg,
  type BrokersMtmTransportationProvidersSetSecretCreateApiResponse,
  type BrokersMtmWebhookCreateApiArg,
  type BrokersMtmWebhookCreateApiResponse,
  type BrokersProvideARideOauth2TokenCreateApiArg,
  type BrokersProvideARideOauth2TokenCreateApiResponse,
  type BrokersProvideARideTripsCreateApiArg,
  type BrokersProvideARideTripsCreateApiResponse,
  type BrokersProvideARideTripsRetrieveApiArg,
  type BrokersProvideARideTripsRetrieveApiResponse,
  type BrokersProvideARideTripsCancelCreateApiArg,
  type BrokersProvideARideTripsCancelCreateApiResponse,
  type BrokersVectorcareWebhookCreateApiArg,
  type BrokersVectorcareWebhookCreateApiResponse,
  type BrokersVeridaClaimsListApiArg,
  type BrokersVeridaClaimsListApiResponse,
  type BrokersVeridaClaimsRetryCreateApiArg,
  type BrokersVeridaClaimsRetryCreateApiResponse,
  type CredentialsListApiArg,
  type CredentialsListApiResponse,
  type CredentialsCreateApiArg,
  type CredentialsCreateApiResponse,
  type CredentialsDestroyApiArg,
  type CredentialsDestroyApiResponse,
  type CredentialsRetrieveApiArg,
  type CredentialsRetrieveApiResponse,
  type CredentialsPartialUpdateApiArg,
  type CredentialsPartialUpdateApiResponse,
  type CredentialsExpiringSoonCountRetrieveApiArg,
  type CredentialsExpiringSoonCountRetrieveApiResponse,
  type CredentialsTypesListApiArg,
  type CredentialsTypesListApiResponse,
  type CredentialsTypesCreateApiArg,
  type CredentialsTypesCreateApiResponse,
  type CredentialsTypesDestroyApiArg,
  type CredentialsTypesDestroyApiResponse,
  type CredentialsTypesRetrieveApiArg,
  type CredentialsTypesRetrieveApiResponse,
  type CredentialsTypesPartialUpdateApiArg,
  type CredentialsTypesPartialUpdateApiResponse,
  type DailyDigestCreateApiArg,
  type DailyDigestCreateApiResponse,
  type DieCreateApiArg,
  type DieCreateApiResponse,
  type DispatchRetrieveApiArg,
  type DispatchRetrieveApiResponse,
  type DispatchAssignedRetrieveApiArg,
  type DispatchAssignedRetrieveApiResponse,
  type DispatchSummaryRetrieveApiArg,
  type DispatchSummaryRetrieveApiResponse,
  type DispatchUnassignedRetrieveApiArg,
  type DispatchUnassignedRetrieveApiResponse,
  type DriverTagsListApiArg,
  type DriverTagsListApiResponse,
  type DriverTagsCreateApiArg,
  type DriverTagsCreateApiResponse,
  type DriverTagsDestroyApiArg,
  type DriverTagsDestroyApiResponse,
  type DriverTagsRetrieveApiArg,
  type DriverTagsRetrieveApiResponse,
  type DriversListApiArg,
  type DriversListApiResponse,
  type DriversCreateApiArg,
  type DriversCreateApiResponse,
  type DriversPayersListApiArg,
  type DriversPayersListApiResponse,
  type DriversPayersCreateApiArg,
  type DriversPayersCreateApiResponse,
  type DriversDestroyApiArg,
  type DriversDestroyApiResponse,
  type DriversRetrieveApiArg,
  type DriversRetrieveApiResponse,
  type DriversPartialUpdateApiArg,
  type DriversPartialUpdateApiResponse,
  type DriversUndeleteCreateApiArg,
  type DriversUndeleteCreateApiResponse,
  type DriversListSelectedApiArg,
  type DriversListSelectedApiResponse,
  type FilesImportFileListApiArg,
  type FilesImportFileListApiResponse,
  type FilesImportFileCreateApiArg,
  type FilesImportFileCreateApiResponse,
  type FilterGroupsListApiArg,
  type FilterGroupsListApiResponse,
  type FilterGroupsCreateApiArg,
  type FilterGroupsCreateApiResponse,
  type FilterGroupsDestroyApiArg,
  type FilterGroupsDestroyApiResponse,
  type FilterGroupsRetrieveApiArg,
  type FilterGroupsRetrieveApiResponse,
  type FilterGroupsPartialUpdateApiArg,
  type FilterGroupsPartialUpdateApiResponse,
  type FilterGroupsCreateExamplesCreateApiArg,
  type FilterGroupsCreateExamplesCreateApiResponse,
  type FlagsFeatureValuesListApiArg,
  type FlagsFeatureValuesListApiResponse,
  type FlagsFeatureValuesMobileListApiArg,
  type FlagsFeatureValuesMobileListApiResponse,
  type FlagsFeatureValuesWebListApiArg,
  type FlagsFeatureValuesWebListApiResponse,
  type FlagsFeaturesListApiArg,
  type FlagsFeaturesListApiResponse,
  type InternalE2eFactoryRunsCreateApiArg,
  type InternalE2eFactoryRunsCreateApiResponse,
  type InternalE2eFactoryRunsCleanupCreateApiArg,
  type InternalE2eFactoryRunsCleanupCreateApiResponse,
  type InvoicesPayersListApiArg,
  type InvoicesPayersListApiResponse,
  type InvoicesTripsListApiArg,
  type InvoicesTripsListApiResponse,
  type InvoicesExportRetrieveApiArg,
  type InvoicesExportRetrieveApiResponse,
  type InvoicesExportInvoiceEmailsRetrieveApiArg,
  type InvoicesExportInvoiceEmailsRetrieveApiResponse,
  type InvoicesExportPaymentsRetrieveApiArg,
  type InvoicesExportPaymentsRetrieveApiResponse,
  type InvoicePaymentsListSelectedApiArg,
  type InvoicePaymentsListSelectedApiResponse,
  type InvoicesExportRefundsRetrieveApiArg,
  type InvoicesExportRefundsRetrieveApiResponse,
  type InvoiceRefundsListSelectedApiArg,
  type InvoiceRefundsListSelectedApiResponse,
  type InvoiceLineItemsListSelectedApiArg,
  type InvoiceLineItemsListSelectedApiResponse,
  type InvoicesInvoiceEmailListApiArg,
  type InvoicesInvoiceEmailListApiResponse,
  type InvoicesInvoiceEmailCreateApiArg,
  type InvoicesInvoiceEmailCreateApiResponse,
  type InvoicesInvoicesListApiArg,
  type InvoicesInvoicesListApiResponse,
  type InvoicesInvoicesCreateApiArg,
  type InvoicesInvoicesCreateApiResponse,
  type InvoicesInvoicesDestroyApiArg,
  type InvoicesInvoicesDestroyApiResponse,
  type InvoicesInvoicesRetrieveApiArg,
  type InvoicesInvoicesRetrieveApiResponse,
  type InvoicesInvoicesPartialUpdateApiArg,
  type InvoicesInvoicesPartialUpdateApiResponse,
  type InvoicesLineItemsListApiArg,
  type InvoicesLineItemsListApiResponse,
  type InvoicesLineItemsCreateApiArg,
  type InvoicesLineItemsCreateApiResponse,
  type InvoicesLineItemsDestroyApiArg,
  type InvoicesLineItemsDestroyApiResponse,
  type InvoicesLineItemsRetrieveApiArg,
  type InvoicesLineItemsRetrieveApiResponse,
  type InvoicesLineItemsPartialUpdateApiArg,
  type InvoicesLineItemsPartialUpdateApiResponse,
  type InvoicesPaymentLinkListApiArg,
  type InvoicesPaymentLinkListApiResponse,
  type InvoicesPaymentLinkCreateApiArg,
  type InvoicesPaymentLinkCreateApiResponse,
  type InvoicesPaymentLinkEmailCreateApiArg,
  type InvoicesPaymentLinkEmailCreateApiResponse,
  type InvoicesPaymentLinkRetrieveApiArg,
  type InvoicesPaymentLinkRetrieveApiResponse,
  type InvoicesPaymentLinkPartialUpdateApiArg,
  type InvoicesPaymentLinkPartialUpdateApiResponse,
  type InvoicesPaymentsListApiArg,
  type InvoicesPaymentsListApiResponse,
  type InvoicesPaymentsCreateApiArg,
  type InvoicesPaymentsCreateApiResponse,
  type InvoicesPaymentsRetrieveApiArg,
  type InvoicesPaymentsRetrieveApiResponse,
  type InvoicesRefundsListApiArg,
  type InvoicesRefundsListApiResponse,
  type InvoicesRefundsCreateApiArg,
  type InvoicesRefundsCreateApiResponse,
  type InvoicesRefundsRetrieveApiArg,
  type InvoicesRefundsRetrieveApiResponse,
  type InvoicesTripFinderListApiArg,
  type InvoicesTripFinderListApiResponse,
  type InvoicesTripFinderRetrieveApiArg,
  type InvoicesTripFinderRetrieveApiResponse,
  type ItineraryRetrieveApiArg,
  type ItineraryRetrieveApiResponse,
  type ItineraryLatenessListApiArg,
  type ItineraryLatenessListApiResponse,
  type ItineraryLatenessDetailApiArg,
  type ItineraryLatenessDetailApiResponse,
  type AssignmentTripLatenessApiArg,
  type AssignmentTripLatenessApiResponse,
  type LocationsAddressesListApiArg,
  type LocationsAddressesListApiResponse,
  type LocationsAddressesRetrieveApiArg,
  type LocationsAddressesRetrieveApiResponse,
  type LocationsCountiesListApiArg,
  type LocationsCountiesListApiResponse,
  type LocationsGeolocationsListApiArg,
  type LocationsGeolocationsListApiResponse,
  type LocationsGeolocationsCreateApiArg,
  type LocationsGeolocationsCreateApiResponse,
  type LocationsGeolocationsDestroyApiArg,
  type LocationsGeolocationsDestroyApiResponse,
  type LocationsGeolocationsRetrieveApiArg,
  type LocationsGeolocationsRetrieveApiResponse,
  type LocationsGeolocationsPartialUpdateApiArg,
  type LocationsGeolocationsPartialUpdateApiResponse,
  type LocationsGeolocationsUndeleteCreateApiArg,
  type LocationsGeolocationsUndeleteCreateApiResponse,
  type LocationsLocationLogEntryTripsListApiArg,
  type LocationsLocationLogEntryTripsListApiResponse,
  type LocationsLogCreateApiArg,
  type LocationsLogCreateApiResponse,
  type LocationsMunicipalitiesRetrieveApiArg,
  type LocationsMunicipalitiesRetrieveApiResponse,
  type LocationsPassengerAddressesListApiArg,
  type LocationsPassengerAddressesListApiResponse,
  type LocationsPassengerAddressesCreateApiArg,
  type LocationsPassengerAddressesCreateApiResponse,
  type LocationsPassengerAddressesDestroyApiArg,
  type LocationsPassengerAddressesDestroyApiResponse,
  type LocationsPassengerAddressesRetrieveApiArg,
  type LocationsPassengerAddressesRetrieveApiResponse,
  type LocationsPassengerAddressesPartialUpdateApiArg,
  type LocationsPassengerAddressesPartialUpdateApiResponse,
  type LocationsPassengerAddressesUpdateApiArg,
  type LocationsPassengerAddressesUpdateApiResponse,
  type LocationsZipcodesListApiArg,
  type LocationsZipcodesListApiResponse,
  type MembersListApiArg,
  type MembersListApiResponse,
  type MembersCreateApiArg,
  type MembersCreateApiResponse,
  type MembersDestroyApiArg,
  type MembersDestroyApiResponse,
  type MembersRetrieveApiArg,
  type MembersRetrieveApiResponse,
  type MembersPartialUpdateApiArg,
  type MembersPartialUpdateApiResponse,
  type MembersUndeleteCreateApiArg,
  type MembersUndeleteCreateApiResponse,
  type MembersUpdateEmailCreateApiArg,
  type MembersUpdateEmailCreateApiResponse,
  type MessagesListApiArg,
  type MessagesListApiResponse,
  type MessagesCreateApiArg,
  type MessagesCreateApiResponse,
  type MessagesRetrieveApiArg,
  type MessagesRetrieveApiResponse,
  type MessagesTripMessagesListApiArg,
  type MessagesTripMessagesListApiResponse,
  type MessagesTripMessagesCreateApiArg,
  type MessagesTripMessagesCreateApiResponse,
  type MessagesTripMessagesRetrieveApiArg,
  type MessagesTripMessagesRetrieveApiResponse,
  type MessagesWebHookMessageUpdateCreateApiArg,
  type MessagesWebHookMessageUpdateCreateApiResponse,
  type MobileAppSettingsRetrieveApiArg,
  type MobileAppSettingsRetrieveApiResponse,
  type MobileAppSettingsPartialUpdateApiArg,
  type MobileAppSettingsPartialUpdateApiResponse,
  type NotificationsAllNotificationsListApiArg,
  type NotificationsAllNotificationsListApiResponse,
  type NotificationsAllNotificationsRetrieveApiArg,
  type NotificationsAllNotificationsRetrieveApiResponse,
  type NotificationsAudiencesListApiArg,
  type NotificationsAudiencesListApiResponse,
  type NotificationsAudiencesRetrieveApiArg,
  type NotificationsAudiencesRetrieveApiResponse,
  type NotificationsChannelsListApiArg,
  type NotificationsChannelsListApiResponse,
  type NotificationsChannelsRetrieveApiArg,
  type NotificationsChannelsRetrieveApiResponse,
  type NotificationsMemberSettingsListApiArg,
  type NotificationsMemberSettingsListApiResponse,
  type NotificationsMemberSettingsCreateApiArg,
  type NotificationsMemberSettingsCreateApiResponse,
  type NotificationsMemberSettingsRetrieveApiArg,
  type NotificationsMemberSettingsRetrieveApiResponse,
  type NotificationsMemberSettingsPartialUpdateApiArg,
  type NotificationsMemberSettingsPartialUpdateApiResponse,
  type NotificationsNotificationsListApiArg,
  type NotificationsNotificationsListApiResponse,
  type NotificationsNotificationsRetrieveApiArg,
  type NotificationsNotificationsRetrieveApiResponse,
  type NotificationsNotificationsPartialUpdateApiArg,
  type NotificationsNotificationsPartialUpdateApiResponse,
  type NotificationsNotificationsCountRetrieveApiArg,
  type NotificationsNotificationsCountRetrieveApiResponse,
  type NotificationsNotificationsMarkAllReadPartialUpdateApiArg,
  type NotificationsNotificationsMarkAllReadPartialUpdateApiResponse,
  type NotificationsNotificationsMarkAllSeenPartialUpdateApiArg,
  type NotificationsNotificationsMarkAllSeenPartialUpdateApiResponse,
  type NotificationsRoleSettingsListApiArg,
  type NotificationsRoleSettingsListApiResponse,
  type NotificationsRoleSettingsCreateApiArg,
  type NotificationsRoleSettingsCreateApiResponse,
  type NotificationsRoleSettingsRetrieveApiArg,
  type NotificationsRoleSettingsRetrieveApiResponse,
  type NotificationsRoleSettingsPartialUpdateApiArg,
  type NotificationsRoleSettingsPartialUpdateApiResponse,
  type OrganizationBillingStatusRetrieveApiArg,
  type OrganizationBillingStatusRetrieveApiResponse,
  type OrganizationInternalSettingsPartialUpdateApiArg,
  type OrganizationInternalSettingsPartialUpdateApiResponse,
  type OrganizationSettingsRetrieveApiArg,
  type OrganizationSettingsRetrieveApiResponse,
  type OrganizationSettingsPartialUpdateApiArg,
  type OrganizationSettingsPartialUpdateApiResponse,
  type OrganizationSettingsConnectMerchantAccountCreateApiArg,
  type OrganizationSettingsConnectMerchantAccountCreateApiResponse,
  type OrganizationSettingsLogoRetrieveApiArg,
  type OrganizationSettingsLogoRetrieveApiResponse,
  type PassengerImportCreateApiArg,
  type PassengerImportCreateApiResponse,
  type PassengerImportRetrieveApiArg,
  type PassengerImportRetrieveApiResponse,
  type PassengerTagsListApiArg,
  type PassengerTagsListApiResponse,
  type PassengerTagsCreateApiArg,
  type PassengerTagsCreateApiResponse,
  type PassengerTagsDestroyApiArg,
  type PassengerTagsDestroyApiResponse,
  type PassengerTagsRetrieveApiArg,
  type PassengerTagsRetrieveApiResponse,
  type PassengersListApiArg,
  type PassengersListApiResponse,
  type PassengersCreateApiArg,
  type PassengersCreateApiResponse,
  type PassengersAlternateIdentifiersListApiArg,
  type PassengersAlternateIdentifiersListApiResponse,
  type PassengersAlternateIdentifiersCreateApiArg,
  type PassengersAlternateIdentifiersCreateApiResponse,
  type PassengersAlternateIdentifiersDestroyApiArg,
  type PassengersAlternateIdentifiersDestroyApiResponse,
  type PassengersAlternateIdentifiersRetrieveApiArg,
  type PassengersAlternateIdentifiersRetrieveApiResponse,
  type PassengersAlternateIdentifiersPartialUpdateApiArg,
  type PassengersAlternateIdentifiersPartialUpdateApiResponse,
  type PassengersPreferredDriversListApiArg,
  type PassengersPreferredDriversListApiResponse,
  type PassengersPreferredDriversCreateApiArg,
  type PassengersPreferredDriversCreateApiResponse,
  type PassengersPreferredDriversDestroyApiArg,
  type PassengersPreferredDriversDestroyApiResponse,
  type PassengersPreferredDriversRetrieveApiArg,
  type PassengersPreferredDriversRetrieveApiResponse,
  type PassengersPreferredDriversPartialUpdateApiArg,
  type PassengersPreferredDriversPartialUpdateApiResponse,
  type PassengersDestroyApiArg,
  type PassengersDestroyApiResponse,
  type PassengersRetrieveApiArg,
  type PassengersRetrieveApiResponse,
  type PassengersPartialUpdateApiArg,
  type PassengersPartialUpdateApiResponse,
  type PassengersRecentAddressesListApiArg,
  type PassengersRecentAddressesListApiResponse,
  type PassengersRecentPayersListApiArg,
  type PassengersRecentPayersListApiResponse,
  type PassengersUndeleteCreateApiArg,
  type PassengersUndeleteCreateApiResponse,
  type PassengersDuplicatesListApiArg,
  type PassengersDuplicatesListApiResponse,
  type PassengersExportRetrieveApiArg,
  type PassengersExportRetrieveApiResponse,
  type PassengersMergeCreateApiArg,
  type PassengersMergeCreateApiResponse,
  type PayerInfoImportTemplateListApiArg,
  type PayerInfoImportTemplateListApiResponse,
  type PayerSettingsListApiArg,
  type PayerSettingsListApiResponse,
  type PayerSettingsRetrieveApiArg,
  type PayerSettingsRetrieveApiResponse,
  type PayerSettingsPartialUpdateApiArg,
  type PayerSettingsPartialUpdateApiResponse,
  type PayerinfoListApiArg,
  type PayerinfoListApiResponse,
  type PayerinfoRetrieveApiArg,
  type PayerinfoRetrieveApiResponse,
  type PayersListApiArg,
  type PayersListApiResponse,
  type PayersCreateApiArg,
  type PayersCreateApiResponse,
  type PayersDriversListApiArg,
  type PayersDriversListApiResponse,
  type PayersDriversCreateApiArg,
  type PayersDriversCreateApiResponse,
  type PayersPassengersDestroyApiArg,
  type PayersPassengersDestroyApiResponse,
  type PayersPassengersRetrieveApiArg,
  type PayersPassengersRetrieveApiResponse,
  type PayersPassengersPartialUpdateApiArg,
  type PayersPassengersPartialUpdateApiResponse,
  type PayersPassengersCreateApiArg,
  type PayersPassengersCreateApiResponse,
  type PayersSettingsRetrieveApiArg,
  type PayersSettingsRetrieveApiResponse,
  type PayersSettingsPartialUpdateApiArg,
  type PayersSettingsPartialUpdateApiResponse,
  type PayersVehiclesListApiArg,
  type PayersVehiclesListApiResponse,
  type PayersVehiclesCreateApiArg,
  type PayersVehiclesCreateApiResponse,
  type PayersDestroyApiArg,
  type PayersDestroyApiResponse,
  type PayersRetrieveApiArg,
  type PayersRetrieveApiResponse,
  type PayersPartialUpdateApiArg,
  type PayersPartialUpdateApiResponse,
  type PayersMultiloadingPartnersRetrieveApiArg,
  type PayersMultiloadingPartnersRetrieveApiResponse,
  type PayersListSelectedApiArg,
  type PayersListSelectedApiResponse,
  type PayersandtemplatesRetrieveApiArg,
  type PayersandtemplatesRetrieveApiResponse,
  type PayerstemplatesListApiArg,
  type PayerstemplatesListApiResponse,
  type PayerstemplatesRetrieveApiArg,
  type PayerstemplatesRetrieveApiResponse,
  type PricingPriceQuoteCreateApiArg,
  type PricingPriceQuoteCreateApiResponse,
  type PricingPricingSchemeConflictsCreateApiArg,
  type PricingPricingSchemeConflictsCreateApiResponse,
  type PricingPricingSchemesListApiArg,
  type PricingPricingSchemesListApiResponse,
  type PricingPricingSchemesCreateApiArg,
  type PricingPricingSchemesCreateApiResponse,
  type PricingPricingSchemesDestroyApiArg,
  type PricingPricingSchemesDestroyApiResponse,
  type PricingPricingSchemesRetrieveApiArg,
  type PricingPricingSchemesRetrieveApiResponse,
  type PricingPricingSchemesPartialUpdateApiArg,
  type PricingPricingSchemesPartialUpdateApiResponse,
  type ProfileRetrieveApiArg,
  type ProfileRetrieveApiResponse,
  type ReportsCustomReportsListApiArg,
  type ReportsCustomReportsListApiResponse,
  type ReportsCustomReportsCreateApiArg,
  type ReportsCustomReportsCreateApiResponse,
  type ReportsCustomReportsDestroyApiArg,
  type ReportsCustomReportsDestroyApiResponse,
  type ReportsCustomReportsRetrieveApiArg,
  type ReportsCustomReportsRetrieveApiResponse,
  type ReportsCustomReportsPartialUpdateApiArg,
  type ReportsCustomReportsPartialUpdateApiResponse,
  type ReportsTripsLoadedMileageCountCreateApiArg,
  type ReportsTripsLoadedMileageCountCreateApiResponse,
  type ReportsTripsOnTimeCountCreateApiArg,
  type ReportsTripsOnTimeCountCreateApiResponse,
  type ReportsTripsRevenueCountCreateApiArg,
  type ReportsTripsRevenueCountCreateApiResponse,
  type ReportsTripsStatusCountCreateApiArg,
  type ReportsTripsStatusCountCreateApiResponse,
  type RunBambiRunCreateApiArg,
  type RunBambiRunCreateApiResponse,
  type RunBambiRunRetrieveApiArg,
  type RunBambiRunRetrieveApiResponse,
  type RunBambiRunApplyCreateApiArg,
  type RunBambiRunApplyCreateApiResponse,
  type SignaturesListApiArg,
  type SignaturesListApiResponse,
  type SignaturesCreateApiArg,
  type SignaturesCreateApiResponse,
  type SignaturesDestroyApiArg,
  type SignaturesDestroyApiResponse,
  type SignaturesRetrieveApiArg,
  type SignaturesRetrieveApiResponse,
  type TagsListApiArg,
  type TagsListApiResponse,
  type TagsCreateApiArg,
  type TagsCreateApiResponse,
  type TagsDestroyApiArg,
  type TagsDestroyApiResponse,
  type TagsRetrieveApiArg,
  type TagsRetrieveApiResponse,
  type TagsPartialUpdateApiArg,
  type TagsPartialUpdateApiResponse,
  type TilledPaymentMethodDestroyApiArg,
  type TilledPaymentMethodDestroyApiResponse,
  type TilledPaymentMethodRetrieveApiArg,
  type TilledPaymentMethodRetrieveApiResponse,
  type TilledPaymentMethodCreateApiArg,
  type TilledPaymentMethodCreateApiResponse,
  type TilledPaymentMethodPartialUpdateApiArg,
  type TilledPaymentMethodPartialUpdateApiResponse,
  type TilledPaymentMethodVerifyRetrieveApiArg,
  type TilledPaymentMethodVerifyRetrieveApiResponse,
  type TilledPaymentMethodVerifyCreateApiArg,
  type TilledPaymentMethodVerifyCreateApiResponse,
  type TilledPayoutsListApiArg,
  type TilledPayoutsListApiResponse,
  type TilledPayoutsExportCreateApiArg,
  type TilledPayoutsExportCreateApiResponse,
  type TilledResourceLinkCreateApiArg,
  type TilledResourceLinkCreateApiResponse,
  type TilledWebhookCreateApiArg,
  type TilledWebhookCreateApiResponse,
  type TokensChatIssueRetrieveApiArg,
  type TokensChatIssueRetrieveApiResponse,
  type TokensPushRegisterCreateApiArg,
  type TokensPushRegisterCreateApiResponse,
  type TokensPushRevokeCreateApiArg,
  type TokensPushRevokeCreateApiResponse,
  type TripImportCreateApiArg,
  type TripImportCreateApiResponse,
  type TripImportRetrieveApiArg,
  type TripImportRetrieveApiResponse,
  type TripRequestEmbedListApiArg,
  type TripRequestEmbedListApiResponse,
  type TripRequestEmbedCreateApiArg,
  type TripRequestEmbedCreateApiResponse,
  type TripRequestEmbedDestroyApiArg,
  type TripRequestEmbedDestroyApiResponse,
  type TripRequestEmbedRetrieveApiArg,
  type TripRequestEmbedRetrieveApiResponse,
  type TripRequestEmbedPartialUpdateApiArg,
  type TripRequestEmbedPartialUpdateApiResponse,
  type TripTagsListApiArg,
  type TripTagsListApiResponse,
  type TripTagsCreateApiArg,
  type TripTagsCreateApiResponse,
  type TripTagsDestroyApiArg,
  type TripTagsDestroyApiResponse,
  type TripTagsRetrieveApiArg,
  type TripTagsRetrieveApiResponse,
  type VehicleTagsListApiArg,
  type VehicleTagsListApiResponse,
  type VehicleTagsCreateApiArg,
  type VehicleTagsCreateApiResponse,
  type VehicleTagsDestroyApiArg,
  type VehicleTagsDestroyApiResponse,
  type VehicleTagsRetrieveApiArg,
  type VehicleTagsRetrieveApiResponse,
  type VehiclesListApiArg,
  type VehiclesListApiResponse,
  type VehiclesCreateApiArg,
  type VehiclesCreateApiResponse,
  type VehiclesDestroyApiArg,
  type VehiclesDestroyApiResponse,
  type VehiclesRetrieveApiArg,
  type VehiclesRetrieveApiResponse,
  type VehiclesPartialUpdateApiArg,
  type VehiclesPartialUpdateApiResponse,
  type VehiclesPayersListApiArg,
  type VehiclesPayersListApiResponse,
  type VehiclesPayersCreateApiArg,
  type VehiclesPayersCreateApiResponse,
  type VehiclesInspectionCreateApiArg,
  type VehiclesInspectionCreateApiResponse,
  type VehiclesInspectionFieldsListApiArg,
  type VehiclesInspectionFieldsListApiResponse,
  type VehiclesInspectionsListApiArg,
  type VehiclesInspectionsListApiResponse,
  type VehiclesInspectionsRetrieveApiArg,
  type VehiclesInspectionsRetrieveApiResponse,
  type VehiclesInspectionsExportRetrieveApiArg,
  type VehiclesInspectionsExportRetrieveApiResponse,
  type VehiclesListSelectedApiArg,
  type VehiclesListSelectedApiResponse,
  type WebPushSubscriptionListApiArg,
  type WebPushSubscriptionListApiResponse,
  type WebPushSubscriptionCreateApiArg,
  type WebPushSubscriptionCreateApiResponse,
} from './operations.gen.ts';

export const addTagTypes = [
  'attendants',
  'billing',
  'dispatch',
  'drivers',
  'invoices',
  'members',
  'organizations',
  'passengers',
  'payers',
  'preferred-drivers',
  'run-bambi-run',
  'tags',
  'tilled',
  'user',
  'vehicles',
  'brokers',
  'Authentication',
  'trips',
  'CTC',
  'credentials',
  'daily-digest',
  'die',
  'files',
  'filters',
  'flags',
  'internal',
  'itinerary',
  'locations',
  'messages',
  'notifications',
  'organization-billing-status',
  'organization-internal-settings',
  'passenger-import',
  'pricing',
  'reports',
  'signatures',
  'trip-import',
  'trip-request-embed',
  'device',
] as const;

export const bambiApi = coreApi
  .enhanceEndpoints({ addTagTypes })
  .injectEndpoints({
    endpoints: (build) => ({
      attendantsList: build.query<
        AttendantsListApiResponse,
        AttendantsListApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            id: queryArg.id,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['attendants'],
      }),
      attendantsCreate: build.mutation<
        AttendantsCreateApiResponse,
        AttendantsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/`,
          method: 'POST',
          body: queryArg.attendantWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants', 'members'],
      }),
      attendantsDestroy: build.mutation<
        AttendantsDestroyApiResponse,
        AttendantsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsRetrieve: build.query<
        AttendantsRetrieveApiResponse,
        AttendantsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['attendants'],
      }),
      attendantsPartialUpdate: build.mutation<
        AttendantsPartialUpdateApiResponse,
        AttendantsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAttendantWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsCreate: build.mutation<
        AttendantsSkillsCreateApiResponse,
        AttendantsSkillsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/`,
          method: 'POST',
          body: queryArg.attendantSkillsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsDestroy: build.mutation<
        AttendantsSkillsDestroyApiResponse,
        AttendantsSkillsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsRetrieve: build.query<
        AttendantsSkillsRetrieveApiResponse,
        AttendantsSkillsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['attendants'],
      }),
      attendantsSkillsPartialUpdate: build.mutation<
        AttendantsSkillsPartialUpdateApiResponse,
        AttendantsSkillsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedAttendantSkillsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      attendantsSkillsUpdate: build.mutation<
        AttendantsSkillsUpdateApiResponse,
        AttendantsSkillsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/attendants/skills/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.attendantSkillsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['attendants'],
      }),
      billingBillingSettingsRetrieve: build.query<
        BillingBillingSettingsRetrieveApiResponse,
        BillingBillingSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['billing'],
      }),
      billingBillingSettingsPartialUpdate: build.mutation<
        BillingBillingSettingsPartialUpdateApiResponse,
        BillingBillingSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/`,
          method: 'PATCH',
          body: queryArg.patchedBillingSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['billing'],
      }),
      billingBillingSettingsNextInvoiceNumberRetrieve: build.query<
        BillingBillingSettingsNextInvoiceNumberRetrieveApiResponse,
        BillingBillingSettingsNextInvoiceNumberRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/billing-settings/next-invoice-number/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['billing'],
      }),
      billingTripsBillingList: build.query<
        BillingTripsBillingListApiResponse,
        BillingTripsBillingListApiArg
      >({
        query: (queryArg) => ({
          url: `/billing/trips-billing/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['billing'],
      }),
      brokersAliviAdminList: build.query<
        BrokersAliviAdminListApiResponse,
        BrokersAliviAdminListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/admin/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersAliviAdminCreate: build.mutation<
        BrokersAliviAdminCreateApiResponse,
        BrokersAliviAdminCreateApiArg
      >({
        query: () => ({ url: `/brokers/alivi/admin/`, method: 'POST' }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviOauth2TokenCreate: build.mutation<
        BrokersAliviOauth2TokenCreateApiResponse,
        BrokersAliviOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/oauth2/token/`,
          method: 'POST',
          body: queryArg.aliviOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersAliviRideActivateWillcallCreate: build.mutation<
        BrokersAliviRideActivateWillcallCreateApiResponse,
        BrokersAliviRideActivateWillcallCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/activateWillcall/`,
          method: 'POST',
          body: queryArg.aliviRideActivateWillCall,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideCancelCreate: build.mutation<
        BrokersAliviRideCancelCreateApiResponse,
        BrokersAliviRideCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/cancel/`,
          method: 'POST',
          body: queryArg.aliviRideCancel,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideCancelWillcallActivationCreate: build.mutation<
        BrokersAliviRideCancelWillcallActivationCreateApiResponse,
        BrokersAliviRideCancelWillcallActivationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/cancelWillcallActivation/`,
          method: 'POST',
          body: queryArg.aliviRideCancelWillCallActivation,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideGetStatusCreate: build.mutation<
        BrokersAliviRideGetStatusCreateApiResponse,
        BrokersAliviRideGetStatusCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/getStatus/`,
          method: 'POST',
          body: queryArg.aliviRideStatusWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideOfferCreate: build.mutation<
        BrokersAliviRideOfferCreateApiResponse,
        BrokersAliviRideOfferCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/offer/`,
          method: 'POST',
          body: queryArg.aliviRideOffer,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersAliviRideUpdateCreate: build.mutation<
        BrokersAliviRideUpdateCreateApiResponse,
        BrokersAliviRideUpdateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/alivi/ride/update/`,
          method: 'POST',
          body: queryArg.aliviRideUpdate,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersClearviewOauth2TokenCreate: build.mutation<
        BrokersClearviewOauth2TokenCreateApiResponse,
        BrokersClearviewOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/oauth2/token/`,
          method: 'POST',
          body: queryArg.clearviewOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersClearviewTransportPayerList: build.query<
        BrokersClearviewTransportPayerListApiResponse,
        BrokersClearviewTransportPayerListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/transport-payer/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersClearviewTransportPayerCreate: build.mutation<
        BrokersClearviewTransportPayerCreateApiResponse,
        BrokersClearviewTransportPayerCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/transport-payer/`,
          method: 'POST',
          body: queryArg.clearviewTransportPayer,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersClearviewTransportProviderList: build.query<
        BrokersClearviewTransportProviderListApiResponse,
        BrokersClearviewTransportProviderListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/transport-provider/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersClearviewTransportProviderCreate: build.mutation<
        BrokersClearviewTransportProviderCreateApiResponse,
        BrokersClearviewTransportProviderCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/transport-provider/`,
          method: 'POST',
          body: queryArg.clearviewTransportProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersClearviewTripsList: build.query<
        BrokersClearviewTripsListApiResponse,
        BrokersClearviewTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      brokersClearviewTripsCreate: build.mutation<
        BrokersClearviewTripsCreateApiResponse,
        BrokersClearviewTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/`,
          method: 'POST',
          body: queryArg.clearviewTripWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      brokersClearviewTripsRetrieve: build.query<
        BrokersClearviewTripsRetrieveApiResponse,
        BrokersClearviewTripsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trips'],
      }),
      brokersClearviewTripsPartialUpdate: build.mutation<
        BrokersClearviewTripsPartialUpdateApiResponse,
        BrokersClearviewTripsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedClearviewTripWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      brokersClearviewTripsCancelCreate: build.mutation<
        BrokersClearviewTripsCancelCreateApiResponse,
        BrokersClearviewTripsCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/clearview/trips/${queryArg.id}/cancel/`,
          method: 'POST',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trips'],
      }),
      brokersCtcOauth2TokenCreate: build.mutation<
        BrokersCtcOauth2TokenCreateApiResponse,
        BrokersCtcOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/oauth2/token/`,
          method: 'POST',
          body: queryArg.ctcoAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersCtcTripCreate: build.mutation<
        BrokersCtcTripCreateApiResponse,
        BrokersCtcTripCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/`,
          method: 'POST',
          body: queryArg.ctcTrip,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersCtcTripRetrieve: build.query<
        BrokersCtcTripRetrieveApiResponse,
        BrokersCtcTripRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/brokers/ctc/trip/${queryArg.tripId}/` }),
        providesTags: ['CTC'],
      }),
      brokersCtcTripActivationCreate: build.mutation<
        BrokersCtcTripActivationCreateApiResponse,
        BrokersCtcTripActivationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/activation/`,
          method: 'POST',
          body: queryArg.ctcTripActivateWillCall,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersCtcTripCancelCreate: build.mutation<
        BrokersCtcTripCancelCreateApiResponse,
        BrokersCtcTripCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trip/cancel/`,
          method: 'POST',
          body: queryArg.ctcTripCancel,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersCtcTripsList: build.query<
        BrokersCtcTripsListApiResponse,
        BrokersCtcTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/ctc/trips/`,
          params: {
            intermediary_id: queryArg.intermediaryId,
            organization_id: queryArg.organizationId,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            scheduled_pickup_at__gte: queryArg.scheduledPickupAtGte,
            scheduled_pickup_at__lte: queryArg.scheduledPickupAtLte,
          },
        }),
        providesTags: ['CTC'],
      }),
      brokersExampleHelloWorldRetrieve: build.query<
        BrokersExampleHelloWorldRetrieveApiResponse,
        BrokersExampleHelloWorldRetrieveApiArg
      >({
        query: () => ({ url: `/brokers/example/hello_world/` }),
        providesTags: ['brokers'],
      }),
      brokersKinetikAdminList: build.query<
        BrokersKinetikAdminListApiResponse,
        BrokersKinetikAdminListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/admin/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersKinetikAdminCreate: build.mutation<
        BrokersKinetikAdminCreateApiResponse,
        BrokersKinetikAdminCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/admin/`,
          method: 'POST',
          body: queryArg.kinetikTransporterProviderSettingWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikOauth2TokenCreate: build.mutation<
        BrokersKinetikOauth2TokenCreateApiResponse,
        BrokersKinetikOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/oauth2/token/`,
          method: 'POST',
          body: queryArg.kinetikOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersKinetikV1CancelRideCreate: build.mutation<
        BrokersKinetikV1CancelRideCreateApiResponse,
        BrokersKinetikV1CancelRideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/cancelRide`,
          method: 'POST',
          body: queryArg.kinetikRideReadOnly,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1CreateRidesCreate: build.mutation<
        BrokersKinetikV1CreateRidesCreateApiResponse,
        BrokersKinetikV1CreateRidesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/createRides`,
          method: 'POST',
          body: queryArg.kinetikRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetDriverCreate: build.mutation<
        BrokersKinetikV1GetDriverCreateApiResponse,
        BrokersKinetikV1GetDriverCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getDriver`,
          method: 'POST',
          body: queryArg.kinetikDriverWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetRideCreate: build.mutation<
        BrokersKinetikV1GetRideCreateApiResponse,
        BrokersKinetikV1GetRideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getRide`,
          method: 'POST',
          body: queryArg.kinetikRideReadOnly,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1GetVehicleCreate: build.mutation<
        BrokersKinetikV1GetVehicleCreateApiResponse,
        BrokersKinetikV1GetVehicleCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/getVehicle/`,
          method: 'POST',
          body: queryArg.kinetikVehicleWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersKinetikV1UpdateRidesUpdate: build.mutation<
        BrokersKinetikV1UpdateRidesUpdateApiResponse,
        BrokersKinetikV1UpdateRidesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/kinetik/v1/updateRides`,
          method: 'PUT',
          body: queryArg.kinetikRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersLogsSearchRetrieve: build.query<
        BrokersLogsSearchRetrieveApiResponse,
        BrokersLogsSearchRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/logs/search/`,
          params: { search_term: queryArg.searchTerm },
        }),
        providesTags: ['brokers'],
      }),
      brokersMedidriveWebhooksCreate: build.mutation<
        BrokersMedidriveWebhooksCreateApiResponse,
        BrokersMedidriveWebhooksCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/medidrive/webhooks/${queryArg.organizationId}/`,
          method: 'POST',
          body: queryArg.mediDriveWebhookEvent,
          headers: {
            'X-MediDrive-Webhook-Subscription-Id':
              queryArg.xMediDriveWebhookSubscriptionId,
          },
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareRideCreate: build.mutation<
        BrokersModivcareRideCreateApiResponse,
        BrokersModivcareRideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/${queryArg.transportationProviderId}/ride`,
          method: 'POST',
          body: queryArg.modivcareRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareRideUpdate: build.mutation<
        BrokersModivcareRideUpdateApiResponse,
        BrokersModivcareRideUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/${queryArg.transportationProviderId}/ride/${queryArg.rideId}`,
          method: 'PUT',
          body: queryArg.modivcareRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareRideCancelCreate: build.mutation<
        BrokersModivcareRideCancelCreateApiResponse,
        BrokersModivcareRideCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/${queryArg.transportationProviderId}/ride/${queryArg.rideId}/cancel`,
          method: 'POST',
          body: queryArg.modivcareCancelRide,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareRideEventsRetrieve: build.query<
        BrokersModivcareRideEventsRetrieveApiResponse,
        BrokersModivcareRideEventsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/${queryArg.transportationProviderId}/ride/${queryArg.rideId}/events`,
        }),
        providesTags: ['brokers'],
      }),
      brokersModivcareAdminList: build.query<
        BrokersModivcareAdminListApiResponse,
        BrokersModivcareAdminListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/admin/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersModivcareAdminCreate: build.mutation<
        BrokersModivcareAdminCreateApiResponse,
        BrokersModivcareAdminCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/admin/`,
          method: 'POST',
          body: queryArg.modivcareTransportProviderSetting,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareAdminBackfillCreate: build.mutation<
        BrokersModivcareAdminBackfillCreateApiResponse,
        BrokersModivcareAdminBackfillCreateApiArg
      >({
        query: () => ({
          url: `/brokers/modivcare/admin/backfill`,
          method: 'POST',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareAdminBillableTripsList: build.query<
        BrokersModivcareAdminBillableTripsListApiResponse,
        BrokersModivcareAdminBillableTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/admin/billable-trips`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            sent_at__gte: queryArg.sentAtGte,
            sent_at__lte: queryArg.sentAtLte,
          },
        }),
        providesTags: ['brokers'],
      }),
      brokersModivcareAdminDriversList: build.query<
        BrokersModivcareAdminDriversListApiResponse,
        BrokersModivcareAdminDriversListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/admin/drivers`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersModivcareAdminRideReceiptCreate: build.mutation<
        BrokersModivcareAdminRideReceiptCreateApiResponse,
        BrokersModivcareAdminRideReceiptCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/admin/ride-receipt`,
          method: 'POST',
          body: queryArg.modivcareRideReceiptRequest,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersModivcareOauth2TokenCreate: build.mutation<
        BrokersModivcareOauth2TokenCreateApiResponse,
        BrokersModivcareOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/modivcare/oauth2/token`,
          method: 'POST',
          body: queryArg.modivcareOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersMomentmBrokerAuthList: build.query<
        BrokersMomentmBrokerAuthListApiResponse,
        BrokersMomentmBrokerAuthListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthCreate: build.mutation<
        BrokersMomentmBrokerAuthCreateApiResponse,
        BrokersMomentmBrokerAuthCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/`,
          method: 'POST',
          body: queryArg.momentmBrokerAuthWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthDestroy: build.mutation<
        BrokersMomentmBrokerAuthDestroyApiResponse,
        BrokersMomentmBrokerAuthDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthRetrieve: build.query<
        BrokersMomentmBrokerAuthRetrieveApiResponse,
        BrokersMomentmBrokerAuthRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthPartialUpdate: build.mutation<
        BrokersMomentmBrokerAuthPartialUpdateApiResponse,
        BrokersMomentmBrokerAuthPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMomentmBrokerAuthWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthUpdate: build.mutation<
        BrokersMomentmBrokerAuthUpdateApiResponse,
        BrokersMomentmBrokerAuthUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.momentmBrokerAuthWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmBrokerAuthSetSecretCreate: build.mutation<
        BrokersMomentmBrokerAuthSetSecretCreateApiResponse,
        BrokersMomentmBrokerAuthSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/broker-auth/set_secret/`,
          method: 'POST',
          body: queryArg.momentmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMomentmSetSecretCreate: build.mutation<
        BrokersMomentmSetSecretCreateApiResponse,
        BrokersMomentmSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/momentm/set-secret/`,
          method: 'POST',
          body: queryArg.momentmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMoviWebhookCreate: build.mutation<
        BrokersMoviWebhookCreateApiResponse,
        BrokersMoviWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/movi/webhook/${queryArg.moviOrganizationId}/`,
          method: 'POST',
          body: queryArg.moviTrip,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmInitCreate: build.mutation<
        BrokersMtmInitCreateApiResponse,
        BrokersMtmInitCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/init/`,
          method: 'POST',
          body: queryArg.mtmTransportationProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmOauth2TokenCreate: build.mutation<
        BrokersMtmOauth2TokenCreateApiResponse,
        BrokersMtmOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/oauth2/token/`,
          method: 'POST',
          body: queryArg.mtmoAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersMtmSetSecretCreate: build.mutation<
        BrokersMtmSetSecretCreateApiResponse,
        BrokersMtmSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/set-secret/`,
          method: 'POST',
          body: queryArg.mtmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersList: build.query<
        BrokersMtmTransportationProvidersListApiResponse,
        BrokersMtmTransportationProvidersListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersCreate: build.mutation<
        BrokersMtmTransportationProvidersCreateApiResponse,
        BrokersMtmTransportationProvidersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/`,
          method: 'POST',
          body: queryArg.mtmTransportationProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersDestroy: build.mutation<
        BrokersMtmTransportationProvidersDestroyApiResponse,
        BrokersMtmTransportationProvidersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersRetrieve: build.query<
        BrokersMtmTransportationProvidersRetrieveApiResponse,
        BrokersMtmTransportationProvidersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersPartialUpdate: build.mutation<
        BrokersMtmTransportationProvidersPartialUpdateApiResponse,
        BrokersMtmTransportationProvidersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMtmTransportationProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersUpdate: build.mutation<
        BrokersMtmTransportationProvidersUpdateApiResponse,
        BrokersMtmTransportationProvidersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.mtmTransportationProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersBackfillTripsCreate: build.mutation<
        BrokersMtmTransportationProvidersBackfillTripsCreateApiResponse,
        BrokersMtmTransportationProvidersBackfillTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/backfill-trips/`,
          method: 'POST',
          body: queryArg.mtmBackfillTripsRequest,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersGetEmailRetrieve: build.query<
        BrokersMtmTransportationProvidersGetEmailRetrieveApiResponse,
        BrokersMtmTransportationProvidersGetEmailRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/get-email/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersTurnbackReasonsRetrieve: build.query<
        BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiResponse,
        BrokersMtmTransportationProvidersTurnbackReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/${queryArg.id}/turnback-reasons/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersBackfillRunsList: build.query<
        BrokersMtmTransportationProvidersBackfillRunsListApiResponse,
        BrokersMtmTransportationProvidersBackfillRunsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/backfill-runs/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersGetEmailTextRetrieve: build.query<
        BrokersMtmTransportationProvidersGetEmailTextRetrieveApiResponse,
        BrokersMtmTransportationProvidersGetEmailTextRetrieveApiArg
      >({
        query: () => ({
          url: `/brokers/mtm/transportation-providers/get_email_text/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersInitCreate: build.mutation<
        BrokersMtmTransportationProvidersInitCreateApiResponse,
        BrokersMtmTransportationProvidersInitCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/init/`,
          method: 'POST',
          body: queryArg.mtmTransportationProviderWritable,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmTransportationProvidersSetSecretCreate: build.mutation<
        BrokersMtmTransportationProvidersSetSecretCreateApiResponse,
        BrokersMtmTransportationProvidersSetSecretCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/transportation-providers/set_secret/`,
          method: 'POST',
          body: queryArg.mtmSecret,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersMtmWebhookCreate: build.mutation<
        BrokersMtmWebhookCreateApiResponse,
        BrokersMtmWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/mtm/webhook/${queryArg.webhookId}/`,
          method: 'POST',
          body: queryArg.mtmWebhook,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersProvideARideOauth2TokenCreate: build.mutation<
        BrokersProvideARideOauth2TokenCreateApiResponse,
        BrokersProvideARideOauth2TokenCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/oauth2/token/`,
          method: 'POST',
          body: queryArg.provideARideOAuthToken,
        }),
        invalidatesTags: ['Authentication'],
      }),
      brokersProvideARideTripsCreate: build.mutation<
        BrokersProvideARideTripsCreateApiResponse,
        BrokersProvideARideTripsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/`,
          method: 'POST',
          body: queryArg.provideARideTripCreate,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersProvideARideTripsRetrieve: build.query<
        BrokersProvideARideTripsRetrieveApiResponse,
        BrokersProvideARideTripsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/${queryArg.id}/`,
        }),
        providesTags: ['brokers'],
      }),
      brokersProvideARideTripsCancelCreate: build.mutation<
        BrokersProvideARideTripsCancelCreateApiResponse,
        BrokersProvideARideTripsCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/provide-a-ride/trips/${queryArg.id}/cancel/`,
          method: 'POST',
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersVectorcareWebhookCreate: build.mutation<
        BrokersVectorcareWebhookCreateApiResponse,
        BrokersVectorcareWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/vectorcare/webhook/${queryArg.vectorcareOrganizationId}/`,
          method: 'POST',
          body: queryArg.vectorCareTrip,
        }),
        invalidatesTags: ['brokers'],
      }),
      brokersVeridaClaimsList: build.query<
        BrokersVeridaClaimsListApiResponse,
        BrokersVeridaClaimsListApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/verida/claims`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['brokers'],
      }),
      brokersVeridaClaimsRetryCreate: build.mutation<
        BrokersVeridaClaimsRetryCreateApiResponse,
        BrokersVeridaClaimsRetryCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/brokers/verida/claims/retry`,
          method: 'POST',
          body: queryArg.veridaTripClaimRetry,
        }),
        invalidatesTags: ['brokers'],
      }),
      credentialsList: build.query<
        CredentialsListApiResponse,
        CredentialsListApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/`,
          params: {
            credential_type_category: queryArg.credentialTypeCategory,
            credential_types: queryArg.credentialTypes,
            members: queryArg.members,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['credentials'],
      }),
      credentialsCreate: build.mutation<
        CredentialsCreateApiResponse,
        CredentialsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/`,
          method: 'POST',
          body: queryArg.credentialWritable,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsDestroy: build.mutation<
        CredentialsDestroyApiResponse,
        CredentialsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsRetrieve: build.query<
        CredentialsRetrieveApiResponse,
        CredentialsRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/credentials/${queryArg.id}/` }),
        providesTags: ['credentials'],
      }),
      credentialsPartialUpdate: build.mutation<
        CredentialsPartialUpdateApiResponse,
        CredentialsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCredentialWritable,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsExpiringSoonCountRetrieve: build.query<
        CredentialsExpiringSoonCountRetrieveApiResponse,
        CredentialsExpiringSoonCountRetrieveApiArg
      >({
        query: () => ({ url: `/credentials/expiring-soon-count/` }),
        providesTags: ['credentials'],
      }),
      credentialsTypesList: build.query<
        CredentialsTypesListApiResponse,
        CredentialsTypesListApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/`,
          params: {
            category: queryArg.category,
            description: queryArg.description,
            id: queryArg.id,
            name: queryArg.name,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['credentials'],
      }),
      credentialsTypesCreate: build.mutation<
        CredentialsTypesCreateApiResponse,
        CredentialsTypesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/`,
          method: 'POST',
          body: queryArg.credentialTypeWritable,
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsTypesDestroy: build.mutation<
        CredentialsTypesDestroyApiResponse,
        CredentialsTypesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/${queryArg.id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['credentials'],
      }),
      credentialsTypesRetrieve: build.query<
        CredentialsTypesRetrieveApiResponse,
        CredentialsTypesRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/credentials/types/${queryArg.id}/` }),
        providesTags: ['credentials'],
      }),
      credentialsTypesPartialUpdate: build.mutation<
        CredentialsTypesPartialUpdateApiResponse,
        CredentialsTypesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/credentials/types/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCredentialTypeWritable,
        }),
        invalidatesTags: ['credentials'],
      }),
      dailyDigestCreate: build.mutation<
        DailyDigestCreateApiResponse,
        DailyDigestCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/daily-digest/`,
          method: 'POST',
          body: queryArg.dailyDigestWritable,
        }),
        invalidatesTags: ['daily-digest'],
      }),
      dieCreate: build.mutation<DieCreateApiResponse, DieCreateApiArg>({
        query: (queryArg) => ({
          url: `/die/${queryArg.code}/`,
          method: 'POST',
        }),
        invalidatesTags: ['die'],
      }),
      dispatchRetrieve: build.query<
        DispatchRetrieveApiResponse,
        DispatchRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            county_search: queryArg.countySearch,
            driver_tag_search: queryArg.driverTagSearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_ordering: queryArg.unassignedOrdering,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            vehicle_tag_search: queryArg.vehicleTagSearch,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      dispatchAssignedRetrieve: build.query<
        DispatchAssignedRetrieveApiResponse,
        DispatchAssignedRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/assigned/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            driver_tag_search: queryArg.driverTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle_tag_search: queryArg.vehicleTagSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      dispatchSummaryRetrieve: build.query<
        DispatchSummaryRetrieveApiResponse,
        DispatchSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/summary/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assigned_trip_status: queryArg.assignedTripStatus,
            driver_tag_search: queryArg.driverTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle_tag_search: queryArg.vehicleTagSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      dispatchUnassignedRetrieve: build.query<
        DispatchUnassignedRetrieveApiResponse,
        DispatchUnassignedRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/dispatch/unassigned/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            county_search: queryArg.countySearch,
            passenger_tag_search: queryArg.passengerTagSearch,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            state_search: queryArg.stateSearch,
            trip_tag_search: queryArg.tripTagSearch,
            unassigned_ordering: queryArg.unassignedOrdering,
            unassigned_payers: queryArg.unassignedPayers,
            unassigned_price_max: queryArg.unassignedPriceMax,
            unassigned_price_min: queryArg.unassignedPriceMin,
            unassigned_range_end: queryArg.unassignedRangeEnd,
            unassigned_range_start: queryArg.unassignedRangeStart,
            unassigned_search: queryArg.unassignedSearch,
            unassigned_service_types: queryArg.unassignedServiceTypes,
            unassigned_space_types: queryArg.unassignedSpaceTypes,
            zipcode_search: queryArg.zipcodeSearch,
          },
        }),
        providesTags: ['dispatch'],
      }),
      driverTagsList: build.query<
        DriverTagsListApiResponse,
        DriverTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['drivers', 'tags'],
      }),
      driverTagsCreate: build.mutation<
        DriverTagsCreateApiResponse,
        DriverTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/`,
          method: 'POST',
          body: queryArg.driverTagBulkCreateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
      }),
      driverTagsDestroy: build.mutation<
        DriverTagsDestroyApiResponse,
        DriverTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
      }),
      driverTagsRetrieve: build.query<
        DriverTagsRetrieveApiResponse,
        DriverTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/driver-tags/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tags'],
      }),
      driversList: build.query<DriversListApiResponse, DriversListApiArg>({
        query: (queryArg) => ({
          url: `/drivers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            id: queryArg.id,
            id__in: queryArg.idIn,
            membership_id__in: queryArg.membershipIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['drivers'],
      }),
      driversCreate: build.mutation<
        DriversCreateApiResponse,
        DriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/`,
          method: 'POST',
          body: queryArg.driverWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers', 'members'],
      }),
      driversPayersList: build.query<
        DriversPayersListApiResponse,
        DriversPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.driverId}/payers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['drivers'],
      }),
      driversPayersCreate: build.mutation<
        DriversPayersCreateApiResponse,
        DriversPayersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.driverId}/payers/`,
          method: 'POST',
          body: queryArg.driverPayerOrganization,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversDestroy: build.mutation<
        DriversDestroyApiResponse,
        DriversDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversRetrieve: build.query<
        DriversRetrieveApiResponse,
        DriversRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['drivers'],
      }),
      driversPartialUpdate: build.mutation<
        DriversPartialUpdateApiResponse,
        DriversPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedDriverWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversUndeleteCreate: build.mutation<
        DriversUndeleteCreateApiResponse,
        DriversUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.driverWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['drivers'],
      }),
      driversListSelected: build.query<
        DriversListSelectedApiResponse,
        DriversListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/drivers/list-selected/`,
          method: 'POST',
          body: queryArg.driverFilters,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            id: queryArg.id,
            id__in: queryArg.idIn,
            membership_id__in: queryArg.membershipIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['drivers'],
      }),
      filesImportFileList: build.query<
        FilesImportFileListApiResponse,
        FilesImportFileListApiArg
      >({
        query: (queryArg) => ({
          url: `/files/import-file/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['files'],
      }),
      filesImportFileCreate: build.mutation<
        FilesImportFileCreateApiResponse,
        FilesImportFileCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/files/import-file/`,
          method: 'POST',
          body: queryArg.importFileWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['files'],
      }),
      filterGroupsList: build.query<
        FilterGroupsListApiResponse,
        FilterGroupsListApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['filters'],
      }),
      filterGroupsCreate: build.mutation<
        FilterGroupsCreateApiResponse,
        FilterGroupsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/`,
          method: 'POST',
          body: queryArg.filterGroupWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsDestroy: build.mutation<
        FilterGroupsDestroyApiResponse,
        FilterGroupsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsRetrieve: build.query<
        FilterGroupsRetrieveApiResponse,
        FilterGroupsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['filters'],
      }),
      filterGroupsPartialUpdate: build.mutation<
        FilterGroupsPartialUpdateApiResponse,
        FilterGroupsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedFilterGroupWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['filters'],
      }),
      filterGroupsCreateExamplesCreate: build.mutation<
        FilterGroupsCreateExamplesCreateApiResponse,
        FilterGroupsCreateExamplesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/filter-groups/create_examples/`,
          method: 'POST',
          body: queryArg.filterGroupWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['filters'],
      }),
      flagsFeatureValuesList: build.query<
        FlagsFeatureValuesListApiResponse,
        FlagsFeatureValuesListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeatureValuesMobileList: build.query<
        FlagsFeatureValuesMobileListApiResponse,
        FlagsFeatureValuesMobileListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values-mobile/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeatureValuesWebList: build.query<
        FlagsFeatureValuesWebListApiResponse,
        FlagsFeatureValuesWebListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/feature-values-web/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      flagsFeaturesList: build.query<
        FlagsFeaturesListApiResponse,
        FlagsFeaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/flags/features/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['flags'],
      }),
      internalE2eFactoryRunsCreate: build.mutation<
        InternalE2eFactoryRunsCreateApiResponse,
        InternalE2eFactoryRunsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/internal/e2e/factory-runs/`,
          method: 'POST',
          body: queryArg.e2EFactoryRunRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['internal'],
      }),
      internalE2eFactoryRunsCleanupCreate: build.mutation<
        InternalE2eFactoryRunsCleanupCreateApiResponse,
        InternalE2eFactoryRunsCleanupCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/internal/e2e/factory-runs/cleanup/`,
          method: 'POST',
          body: queryArg.e2EFactoryRunRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['internal'],
      }),
      invoicesPayersList: build.query<
        InvoicesPayersListApiResponse,
        InvoicesPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/${queryArg.id}/payers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      invoicesTripsList: build.query<
        InvoicesTripsListApiResponse,
        InvoicesTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/${queryArg.id}/trips/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesExportRetrieve: build.query<
        InvoicesExportRetrieveApiResponse,
        InvoicesExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            created_at: queryArg.createdAt,
            invoice: queryArg.invoice,
            invoice__in: queryArg.invoiceIn,
            ordering: queryArg.ordering,
            output_type: queryArg.outputType,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            trip__in: queryArg.tripIn,
            trip__payer: queryArg.tripPayer,
            trip__payer__in: queryArg.tripPayerIn,
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoicesExportInvoiceEmailsRetrieve: build.query<
        InvoicesExportInvoiceEmailsRetrieveApiResponse,
        InvoicesExportInvoiceEmailsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-invoice-emails/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            sent_at_after: queryArg.sentAtAfter,
            sent_at_before: queryArg.sentAtBefore,
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoicesExportPaymentsRetrieve: build.query<
        InvoicesExportPaymentsRetrieveApiResponse,
        InvoicesExportPaymentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-payments/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoicePaymentsListSelected: build.query<
        InvoicePaymentsListSelectedApiResponse,
        InvoicePaymentsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-payments/list-selected/`,
          method: 'POST',
          body: queryArg.invoicePaymentExportFilter,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoicesExportRefundsRetrieve: build.query<
        InvoicesExportRefundsRetrieveApiResponse,
        InvoicesExportRefundsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-refunds/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoiceRefundsListSelected: build.query<
        InvoiceRefundsListSelectedApiResponse,
        InvoiceRefundsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export-refunds/list-selected/`,
          method: 'POST',
          body: queryArg.invoicesListFilter,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoiceLineItemsListSelected: build.query<
        InvoiceLineItemsListSelectedApiResponse,
        InvoiceLineItemsListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/export/list-selected/`,
          method: 'POST',
          body: queryArg.invoicesListFilter,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            created_at: queryArg.createdAt,
            invoice: queryArg.invoice,
            invoice__in: queryArg.invoiceIn,
            ordering: queryArg.ordering,
            output_type: queryArg.outputType,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            trip__in: queryArg.tripIn,
            trip__payer: queryArg.tripPayer,
            trip__payer__in: queryArg.tripPayerIn,
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      invoicesInvoiceEmailList: build.query<
        InvoicesInvoiceEmailListApiResponse,
        InvoicesInvoiceEmailListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoice-email/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            sent_at_after: queryArg.sentAtAfter,
            sent_at_before: queryArg.sentAtBefore,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoiceEmailCreate: build.mutation<
        InvoicesInvoiceEmailCreateApiResponse,
        InvoicesInvoiceEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoice-email/`,
          method: 'POST',
          body: queryArg.invoiceEmail,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesInvoicesList: build.query<
        InvoicesInvoicesListApiResponse,
        InvoicesInvoicesListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            created_at: queryArg.createdAt,
            date_issued: queryArg.dateIssued,
            date_issued_end: queryArg.dateIssuedEnd,
            date_issued_start: queryArg.dateIssuedStart,
            due_max: queryArg.dueMax,
            due_min: queryArg.dueMin,
            has_emailed_payment_link: queryArg.hasEmailedPaymentLink,
            has_payment_link: queryArg.hasPaymentLink,
            min_payments: queryArg.minPayments,
            ordering: queryArg.ordering,
            overall_payment_status__in: queryArg.overallPaymentStatusIn,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            total_amount_max: queryArg.totalAmountMax,
            total_amount_min: queryArg.totalAmountMin,
            trip_payer__in: queryArg.tripPayerIn,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoicesCreate: build.mutation<
        InvoicesInvoicesCreateApiResponse,
        InvoicesInvoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/`,
          method: 'POST',
          body: queryArg.invoiceWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['billing', 'invoices'],
      }),
      invoicesInvoicesDestroy: build.mutation<
        InvoicesInvoicesDestroyApiResponse,
        InvoicesInvoicesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesInvoicesRetrieve: build.query<
        InvoicesInvoicesRetrieveApiResponse,
        InvoicesInvoicesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesInvoicesPartialUpdate: build.mutation<
        InvoicesInvoicesPartialUpdateApiResponse,
        InvoicesInvoicesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/invoices/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoiceWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsList: build.query<
        InvoicesLineItemsListApiResponse,
        InvoicesLineItemsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['invoices'],
      }),
      invoicesLineItemsCreate: build.mutation<
        InvoicesLineItemsCreateApiResponse,
        InvoicesLineItemsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/`,
          method: 'POST',
          body: queryArg.invoiceLineItemWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsDestroy: build.mutation<
        InvoicesLineItemsDestroyApiResponse,
        InvoicesLineItemsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesLineItemsRetrieve: build.query<
        InvoicesLineItemsRetrieveApiResponse,
        InvoicesLineItemsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesLineItemsPartialUpdate: build.mutation<
        InvoicesLineItemsPartialUpdateApiResponse,
        InvoicesLineItemsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/line-items/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoiceLineItemWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentLinkList: build.query<
        InvoicesPaymentLinkListApiResponse,
        InvoicesPaymentLinkListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            invoice: queryArg.invoice,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payment: queryArg.payment,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentLinkCreate: build.mutation<
        InvoicesPaymentLinkCreateApiResponse,
        InvoicesPaymentLinkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/`,
          method: 'POST',
          body: queryArg.invoicePaymentLinkWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: [],
      }),
      invoicesPaymentLinkEmailCreate: build.mutation<
        InvoicesPaymentLinkEmailCreateApiResponse,
        InvoicesPaymentLinkEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link-email/`,
          method: 'POST',
          body: queryArg.invoicePaymentLinkEmail,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentLinkRetrieve: build.query<
        InvoicesPaymentLinkRetrieveApiResponse,
        InvoicesPaymentLinkRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentLinkPartialUpdate: build.mutation<
        InvoicesPaymentLinkPartialUpdateApiResponse,
        InvoicesPaymentLinkPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payment-link/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedInvoicePaymentLinkWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentsList: build.query<
        InvoicesPaymentsListApiResponse,
        InvoicesPaymentsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            charge_status: queryArg.chargeStatus,
            created_at_after: queryArg.createdAtAfter,
            created_at_before: queryArg.createdAtBefore,
            has_refunds: queryArg.hasRefunds,
            invoice_number: queryArg.invoiceNumber,
            is_manual: queryArg.isManual,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            status: queryArg.status,
            total_amount_cents_max: queryArg.totalAmountCentsMax,
            total_amount_cents_min: queryArg.totalAmountCentsMin,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesPaymentsCreate: build.mutation<
        InvoicesPaymentsCreateApiResponse,
        InvoicesPaymentsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/`,
          method: 'POST',
          body: queryArg.invoicePaymentWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesPaymentsRetrieve: build.query<
        InvoicesPaymentsRetrieveApiResponse,
        InvoicesPaymentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/payments/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesRefundsList: build.query<
        InvoicesRefundsListApiResponse,
        InvoicesRefundsListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['invoices'],
      }),
      invoicesRefundsCreate: build.mutation<
        InvoicesRefundsCreateApiResponse,
        InvoicesRefundsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/`,
          method: 'POST',
          body: queryArg.invoiceRefundWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['invoices'],
      }),
      invoicesRefundsRetrieve: build.query<
        InvoicesRefundsRetrieveApiResponse,
        InvoicesRefundsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/refunds/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesTripFinderList: build.query<
        InvoicesTripFinderListApiResponse,
        InvoicesTripFinderListApiArg
      >({
        query: (queryArg) => ({
          url: `/invoices/trip-finder/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            has_unpaid_invoice: queryArg.hasUnpaidInvoice,
            id__in: queryArg.idIn,
            import_file_id__in: queryArg.importFileIdIn,
            import_template_id__in: queryArg.importTemplateIdIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passenger_tag__in: queryArg.passengerTagIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['invoices'],
      }),
      invoicesTripFinderRetrieve: build.query<
        InvoicesTripFinderRetrieveApiResponse,
        InvoicesTripFinderRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/invoices/trip-finder/${queryArg.id}/` }),
        providesTags: ['invoices'],
      }),
      itineraryRetrieve: build.query<
        ItineraryRetrieveApiResponse,
        ItineraryRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/itinerary/${queryArg.assignmentId}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['itinerary'],
      }),
      itineraryLatenessList: build.query<
        ItineraryLatenessListApiResponse,
        ItineraryLatenessListApiArg
      >({
        query: (queryArg) => ({
          url: `/itinerary/lateness/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['itinerary'],
      }),
      itineraryLatenessDetail: build.query<
        ItineraryLatenessDetailApiResponse,
        ItineraryLatenessDetailApiArg
      >({
        query: (queryArg) => ({
          url: `/itinerary/lateness/${queryArg.assignmentId}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['itinerary'],
      }),
      assignmentTripLateness: build.query<
        AssignmentTripLatenessApiResponse,
        AssignmentTripLatenessApiArg
      >({
        query: (queryArg) => ({
          url: `/itinerary/lateness/${queryArg.assignmentId}/trips/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['itinerary'],
      }),
      locationsAddressesList: build.query<
        LocationsAddressesListApiResponse,
        LocationsAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/addresses/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['locations'],
      }),
      locationsAddressesRetrieve: build.query<
        LocationsAddressesRetrieveApiResponse,
        LocationsAddressesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/addresses/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['locations'],
      }),
      locationsCountiesList: build.query<
        LocationsCountiesListApiResponse,
        LocationsCountiesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/counties/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            county: queryArg.county,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsList: build.query<
        LocationsGeolocationsListApiResponse,
        LocationsGeolocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            deleted_objects: queryArg.deletedObjects,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            source: queryArg.source,
            source__in: queryArg.sourceIn,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsCreate: build.mutation<
        LocationsGeolocationsCreateApiResponse,
        LocationsGeolocationsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/`,
          method: 'POST',
          body: queryArg.geoLocationWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsDestroy: build.mutation<
        LocationsGeolocationsDestroyApiResponse,
        LocationsGeolocationsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsRetrieve: build.query<
        LocationsGeolocationsRetrieveApiResponse,
        LocationsGeolocationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['locations'],
      }),
      locationsGeolocationsPartialUpdate: build.mutation<
        LocationsGeolocationsPartialUpdateApiResponse,
        LocationsGeolocationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedGeoLocationWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsGeolocationsUndeleteCreate: build.mutation<
        LocationsGeolocationsUndeleteCreateApiResponse,
        LocationsGeolocationsUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/geolocations/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.geoLocationWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsLocationLogEntryTripsList: build.query<
        LocationsLocationLogEntryTripsListApiResponse,
        LocationsLocationLogEntryTripsListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/location-log-entry-trips/${queryArg.tripId}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['locations'],
      }),
      locationsLogCreate: build.mutation<
        LocationsLogCreateApiResponse,
        LocationsLogCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/log/`,
          method: 'POST',
          body: queryArg.locationLogEntryWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsMunicipalitiesRetrieve: build.query<
        LocationsMunicipalitiesRetrieveApiResponse,
        LocationsMunicipalitiesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/municipalities/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesList: build.query<
        LocationsPassengerAddressesListApiResponse,
        LocationsPassengerAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesCreate: build.mutation<
        LocationsPassengerAddressesCreateApiResponse,
        LocationsPassengerAddressesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/`,
          method: 'POST',
          body: queryArg.passengerAddressWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesDestroy: build.mutation<
        LocationsPassengerAddressesDestroyApiResponse,
        LocationsPassengerAddressesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesRetrieve: build.query<
        LocationsPassengerAddressesRetrieveApiResponse,
        LocationsPassengerAddressesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['locations'],
      }),
      locationsPassengerAddressesPartialUpdate: build.mutation<
        LocationsPassengerAddressesPartialUpdateApiResponse,
        LocationsPassengerAddressesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassengerAddressRequestWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsPassengerAddressesUpdate: build.mutation<
        LocationsPassengerAddressesUpdateApiResponse,
        LocationsPassengerAddressesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/passenger-addresses/${queryArg.id}/`,
          method: 'PUT',
          body: queryArg.passengerAddressWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['locations'],
      }),
      locationsZipcodesList: build.query<
        LocationsZipcodesListApiResponse,
        LocationsZipcodesListApiArg
      >({
        query: (queryArg) => ({
          url: `/locations/zipcodes/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            zipcode: queryArg.zipcode,
          },
        }),
        providesTags: ['locations'],
      }),
      membersList: build.query<MembersListApiResponse, MembersListApiArg>({
        query: (queryArg) => ({
          url: `/members/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            deleted_objects: queryArg.deletedObjects,
            is_attendant: queryArg.isAttendant,
            is_bambi_staff: queryArg.isBambiStaff,
            is_driver: queryArg.isDriver,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            role: queryArg.role,
            search: queryArg.search,
          },
        }),
        providesTags: ['members'],
      }),
      membersCreate: build.mutation<
        MembersCreateApiResponse,
        MembersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/`,
          method: 'POST',
          body: queryArg.membershipWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersDestroy: build.mutation<
        MembersDestroyApiResponse,
        MembersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersRetrieve: build.query<
        MembersRetrieveApiResponse,
        MembersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['members'],
      }),
      membersPartialUpdate: build.mutation<
        MembersPartialUpdateApiResponse,
        MembersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMembershipWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersUndeleteCreate: build.mutation<
        MembersUndeleteCreateApiResponse,
        MembersUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.membershipWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      membersUpdateEmailCreate: build.mutation<
        MembersUpdateEmailCreateApiResponse,
        MembersUpdateEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/members/${queryArg.id}/update_email/`,
          method: 'POST',
          body: queryArg.updateEmail,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['members'],
      }),
      messagesList: build.query<MessagesListApiResponse, MessagesListApiArg>({
        query: (queryArg) => ({
          url: `/messages/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['messages'],
      }),
      messagesCreate: build.mutation<
        MessagesCreateApiResponse,
        MessagesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/`,
          method: 'POST',
          body: queryArg.messageWritable,
        }),
        invalidatesTags: ['messages'],
      }),
      messagesRetrieve: build.query<
        MessagesRetrieveApiResponse,
        MessagesRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/messages/${queryArg.id}/` }),
        providesTags: ['messages'],
      }),
      messagesTripMessagesList: build.query<
        MessagesTripMessagesListApiResponse,
        MessagesTripMessagesListApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            trip_id: queryArg.tripId,
          },
        }),
        providesTags: ['messages'],
      }),
      messagesTripMessagesCreate: build.mutation<
        MessagesTripMessagesCreateApiResponse,
        MessagesTripMessagesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/`,
          method: 'POST',
          body: queryArg.tripMessageWritable,
        }),
        invalidatesTags: ['messages'],
      }),
      messagesTripMessagesRetrieve: build.query<
        MessagesTripMessagesRetrieveApiResponse,
        MessagesTripMessagesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/trip-messages/${queryArg.tripId}/`,
        }),
        providesTags: ['messages'],
      }),
      messagesWebHookMessageUpdateCreate: build.mutation<
        MessagesWebHookMessageUpdateCreateApiResponse,
        MessagesWebHookMessageUpdateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/messages/web-hook/message-update/`,
          method: 'POST',
          body: queryArg.messageWritable,
        }),
        invalidatesTags: ['messages'],
      }),
      mobileAppSettingsRetrieve: build.query<
        MobileAppSettingsRetrieveApiResponse,
        MobileAppSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/mobile-app-settings/`,
          headers: { 'User-Agent': queryArg.userAgent },
        }),
        providesTags: ['user'],
      }),
      mobileAppSettingsPartialUpdate: build.mutation<
        MobileAppSettingsPartialUpdateApiResponse,
        MobileAppSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/mobile-app-settings/`,
          method: 'PATCH',
          body: queryArg.patchedMobileAppSettings,
          headers: { 'User-Agent': queryArg.userAgent },
        }),
        invalidatesTags: ['user'],
      }),
      notificationsAllNotificationsList: build.query<
        NotificationsAllNotificationsListApiResponse,
        NotificationsAllNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/all-notifications/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAllNotificationsRetrieve: build.query<
        NotificationsAllNotificationsRetrieveApiResponse,
        NotificationsAllNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/all-notifications/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAudiencesList: build.query<
        NotificationsAudiencesListApiResponse,
        NotificationsAudiencesListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/audiences/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsAudiencesRetrieve: build.query<
        NotificationsAudiencesRetrieveApiResponse,
        NotificationsAudiencesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/audiences/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsChannelsList: build.query<
        NotificationsChannelsListApiResponse,
        NotificationsChannelsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/channels/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsChannelsRetrieve: build.query<
        NotificationsChannelsRetrieveApiResponse,
        NotificationsChannelsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/channels/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsList: build.query<
        NotificationsMemberSettingsListApiResponse,
        NotificationsMemberSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsCreate: build.mutation<
        NotificationsMemberSettingsCreateApiResponse,
        NotificationsMemberSettingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/`,
          method: 'POST',
          body: queryArg.notificationMemberSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsMemberSettingsRetrieve: build.query<
        NotificationsMemberSettingsRetrieveApiResponse,
        NotificationsMemberSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsMemberSettingsPartialUpdate: build.mutation<
        NotificationsMemberSettingsPartialUpdateApiResponse,
        NotificationsMemberSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/member-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotificationMemberSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsList: build.query<
        NotificationsNotificationsListApiResponse,
        NotificationsNotificationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            created_at: queryArg.createdAt,
            is_expired: queryArg.isExpired,
            is_read: queryArg.isRead,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            read_at: queryArg.readAt,
            seen_at: queryArg.seenAt,
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsRetrieve: build.query<
        NotificationsNotificationsRetrieveApiResponse,
        NotificationsNotificationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsPartialUpdate: build.mutation<
        NotificationsNotificationsPartialUpdateApiResponse,
        NotificationsNotificationsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotificationWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsCountRetrieve: build.query<
        NotificationsNotificationsCountRetrieveApiResponse,
        NotificationsNotificationsCountRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/count/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsNotificationsMarkAllReadPartialUpdate: build.mutation<
        NotificationsNotificationsMarkAllReadPartialUpdateApiResponse,
        NotificationsNotificationsMarkAllReadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/mark_all_read/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsNotificationsMarkAllSeenPartialUpdate: build.mutation<
        NotificationsNotificationsMarkAllSeenPartialUpdateApiResponse,
        NotificationsNotificationsMarkAllSeenPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/notifications/mark_all_seen/`,
          method: 'PATCH',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsRoleSettingsList: build.query<
        NotificationsRoleSettingsListApiResponse,
        NotificationsRoleSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['notifications'],
      }),
      notificationsRoleSettingsCreate: build.mutation<
        NotificationsRoleSettingsCreateApiResponse,
        NotificationsRoleSettingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/`,
          method: 'POST',
          body: queryArg.notificationRoleSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      notificationsRoleSettingsRetrieve: build.query<
        NotificationsRoleSettingsRetrieveApiResponse,
        NotificationsRoleSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['notifications'],
      }),
      notificationsRoleSettingsPartialUpdate: build.mutation<
        NotificationsRoleSettingsPartialUpdateApiResponse,
        NotificationsRoleSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/notifications/role-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedNotificationRoleSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['notifications'],
      }),
      organizationBillingStatusRetrieve: build.query<
        OrganizationBillingStatusRetrieveApiResponse,
        OrganizationBillingStatusRetrieveApiArg
      >({
        query: () => ({ url: `/organization-billing-status/` }),
        providesTags: ['organization-billing-status'],
      }),
      organizationInternalSettingsPartialUpdate: build.mutation<
        OrganizationInternalSettingsPartialUpdateApiResponse,
        OrganizationInternalSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-internal-settings/`,
          method: 'PATCH',
          body: queryArg.patchedOrganizationInternalSettingsWritable,
        }),
        invalidatesTags: ['organization-internal-settings'],
      }),
      organizationSettingsRetrieve: build.query<
        OrganizationSettingsRetrieveApiResponse,
        OrganizationSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['organizations'],
      }),
      organizationSettingsPartialUpdate: build.mutation<
        OrganizationSettingsPartialUpdateApiResponse,
        OrganizationSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/`,
          method: 'PATCH',
          body: queryArg.patchedOrganizationSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['organizations', 'user'],
      }),
      organizationSettingsConnectMerchantAccountCreate: build.mutation<
        OrganizationSettingsConnectMerchantAccountCreateApiResponse,
        OrganizationSettingsConnectMerchantAccountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/connect-merchant-account/`,
          method: 'POST',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['organizations'],
      }),
      organizationSettingsLogoRetrieve: build.query<
        OrganizationSettingsLogoRetrieveApiResponse,
        OrganizationSettingsLogoRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/organization-settings/logo/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['organizations'],
      }),
      passengerImportCreate: build.mutation<
        PassengerImportCreateApiResponse,
        PassengerImportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-import/`,
          method: 'POST',
          body: queryArg.passengerImportAsyncWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['passenger-import'],
      }),
      passengerImportRetrieve: build.query<
        PassengerImportRetrieveApiResponse,
        PassengerImportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-import/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['passenger-import'],
      }),
      passengerTagsList: build.query<
        PassengerTagsListApiResponse,
        PassengerTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['passengers', 'tags'],
      }),
      passengerTagsCreate: build.mutation<
        PassengerTagsCreateApiResponse,
        PassengerTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/`,
          method: 'POST',
          body: queryArg.passengerTagBulkCreateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'passengers', 'tags'],
      }),
      passengerTagsDestroy: build.mutation<
        PassengerTagsDestroyApiResponse,
        PassengerTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'passengers', 'tags'],
      }),
      passengerTagsRetrieve: build.query<
        PassengerTagsRetrieveApiResponse,
        PassengerTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passenger-tags/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tags'],
      }),
      passengersList: build.query<
        PassengersListApiResponse,
        PassengersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            allow_sms_message: queryArg.allowSmsMessage,
            created_at_end: queryArg.createdAtEnd,
            created_at_start: queryArg.createdAtStart,
            deleted_objects: queryArg.deletedObjects,
            gender: queryArg.gender,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersCreate: build.mutation<
        PassengersCreateApiResponse,
        PassengersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/`,
          method: 'POST',
          body: queryArg.passengerWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['dispatch', 'passengers', 'tags'],
      }),
      passengersAlternateIdentifiersList: build.query<
        PassengersAlternateIdentifiersListApiResponse,
        PassengersAlternateIdentifiersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersCreate: build.mutation<
        PassengersAlternateIdentifiersCreateApiResponse,
        PassengersAlternateIdentifiersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/`,
          method: 'POST',
          body: queryArg.passengerAlternateIdentifierWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersDestroy: build.mutation<
        PassengersAlternateIdentifiersDestroyApiResponse,
        PassengersAlternateIdentifiersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersRetrieve: build.query<
        PassengersAlternateIdentifiersRetrieveApiResponse,
        PassengersAlternateIdentifiersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersAlternateIdentifiersPartialUpdate: build.mutation<
        PassengersAlternateIdentifiersPartialUpdateApiResponse,
        PassengersAlternateIdentifiersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/alternate-identifiers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassengerAlternateIdentifierWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['passengers'],
      }),
      passengersPreferredDriversList: build.query<
        PassengersPreferredDriversListApiResponse,
        PassengersPreferredDriversListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['preferred-drivers'],
      }),
      passengersPreferredDriversCreate: build.mutation<
        PassengersPreferredDriversCreateApiResponse,
        PassengersPreferredDriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/`,
          method: 'POST',
          body: queryArg.preferredDriverWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['preferred-drivers'],
      }),
      passengersPreferredDriversDestroy: build.mutation<
        PassengersPreferredDriversDestroyApiResponse,
        PassengersPreferredDriversDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['preferred-drivers'],
      }),
      passengersPreferredDriversRetrieve: build.query<
        PassengersPreferredDriversRetrieveApiResponse,
        PassengersPreferredDriversRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['preferred-drivers'],
      }),
      passengersPreferredDriversPartialUpdate: build.mutation<
        PassengersPreferredDriversPartialUpdateApiResponse,
        PassengersPreferredDriversPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.passengerId}/preferred-drivers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPreferredDriverWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['preferred-drivers'],
      }),
      passengersDestroy: build.mutation<
        PassengersDestroyApiResponse,
        PassengersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
      }),
      passengersRetrieve: build.query<
        PassengersRetrieveApiResponse,
        PassengersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['passengers'],
      }),
      passengersPartialUpdate: build.mutation<
        PassengersPartialUpdateApiResponse,
        PassengersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPassengerWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['dispatch', 'passengers', 'tags'],
      }),
      passengersRecentAddressesList: build.query<
        PassengersRecentAddressesListApiResponse,
        PassengersRecentAddressesListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/recent-addresses/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            max_results: queryArg.maxResults,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersRecentPayersList: build.query<
        PassengersRecentPayersListApiResponse,
        PassengersRecentPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/recent-payers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            max_results: queryArg.maxResults,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersUndeleteCreate: build.mutation<
        PassengersUndeleteCreateApiResponse,
        PassengersUndeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/${queryArg.id}/undelete/`,
          method: 'POST',
          body: queryArg.passengerWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
      }),
      passengersDuplicatesList: build.query<
        PassengersDuplicatesListApiResponse,
        PassengersDuplicatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/duplicates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            created_at_end: queryArg.createdAtEnd,
            created_at_start: queryArg.createdAtStart,
            first_name_starts_with: queryArg.firstNameStartsWith,
            last_name_starts_with: queryArg.lastNameStartsWith,
            match_fields: queryArg.matchFields,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
          },
        }),
        providesTags: ['passengers'],
      }),
      passengersExportRetrieve: build.query<
        PassengersExportRetrieveApiResponse,
        PassengersExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/export/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      passengersMergeCreate: build.mutation<
        PassengersMergeCreateApiResponse,
        PassengersMergeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/passengers/merge/`,
          method: 'POST',
          body: queryArg.passengerMergeRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['passengers'],
      }),
      payerInfoImportTemplateList: build.query<
        PayerInfoImportTemplateListApiResponse,
        PayerInfoImportTemplateListApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-info-import-template/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payerSettingsList: build.query<
        PayerSettingsListApiResponse,
        PayerSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payerSettingsRetrieve: build.query<
        PayerSettingsRetrieveApiResponse,
        PayerSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payerSettingsPartialUpdate: build.mutation<
        PayerSettingsPartialUpdateApiResponse,
        PayerSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payer-settings/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganizationSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payerinfoList: build.query<PayerinfoListApiResponse, PayerinfoListApiArg>(
        {
          query: (queryArg) => ({
            url: `/payerinfo/`,
            headers: {
              ...(queryArg.organizationId !== undefined && {
                'Organization-ID': queryArg.organizationId,
              }),
            },
            params: {
              ordering: queryArg.ordering,
              page: queryArg.page,
              page_size: queryArg.pageSize,
              search: queryArg.search,
            },
          }),
          providesTags: ['payers'],
        }
      ),
      payerinfoRetrieve: build.query<
        PayerinfoRetrieveApiResponse,
        PayerinfoRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payerinfo/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payersList: build.query<PayersListApiResponse, PayersListApiArg>({
        query: (queryArg) => ({
          url: `/payers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_multiload: queryArg.canMultiload,
            id: queryArg.id,
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer_settings__allow_only_specific_drivers:
              queryArg.payerSettingsAllowOnlySpecificDrivers,
            payer_settings__allow_only_specific_vehicles:
              queryArg.payerSettingsAllowOnlySpecificVehicles,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payersCreate: build.mutation<PayersCreateApiResponse, PayersCreateApiArg>(
        {
          query: (queryArg) => ({
            url: `/payers/`,
            method: 'POST',
            body: queryArg.payerOrganizationWritable,
            headers: {
              ...(queryArg.organizationId !== undefined && {
                'Organization-ID': queryArg.organizationId,
              }),
            },
          }),
          invalidatesTags: ['payers'],
        }
      ),
      payersDriversList: build.query<
        PayersDriversListApiResponse,
        PayersDriversListApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/drivers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payersDriversCreate: build.mutation<
        PayersDriversCreateApiResponse,
        PayersDriversCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/drivers/`,
          method: 'POST',
          body: queryArg.payerOrganizationDriver,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersDestroy: build.mutation<
        PayersPassengersDestroyApiResponse,
        PayersPassengersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersRetrieve: build.query<
        PayersPassengersRetrieveApiResponse,
        PayersPassengersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payersPassengersPartialUpdate: build.mutation<
        PayersPassengersPartialUpdateApiResponse,
        PayersPassengersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerPassengerWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersPassengersCreate: build.mutation<
        PayersPassengersCreateApiResponse,
        PayersPassengersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/passengers/${queryArg.passengerId}/`,
          method: 'POST',
          body: queryArg.payerPassengerWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersSettingsRetrieve: build.query<
        PayersSettingsRetrieveApiResponse,
        PayersSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/settings/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payersSettingsPartialUpdate: build.mutation<
        PayersSettingsPartialUpdateApiResponse,
        PayersSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/settings/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganizationSettingsWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersVehiclesList: build.query<
        PayersVehiclesListApiResponse,
        PayersVehiclesListApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/vehicles/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['payers'],
      }),
      payersVehiclesCreate: build.mutation<
        PayersVehiclesCreateApiResponse,
        PayersVehiclesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.payerOrganizationId}/vehicles/`,
          method: 'POST',
          body: queryArg.payerOrganizationVehicle,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersDestroy: build.mutation<
        PayersDestroyApiResponse,
        PayersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersRetrieve: build.query<
        PayersRetrieveApiResponse,
        PayersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payersPartialUpdate: build.mutation<
        PayersPartialUpdateApiResponse,
        PayersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPayerOrganizationWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['payers'],
      }),
      payersMultiloadingPartnersRetrieve: build.query<
        PayersMultiloadingPartnersRetrieveApiResponse,
        PayersMultiloadingPartnersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/${queryArg.id}/multiloading-partners/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payersListSelected: build.query<
        PayersListSelectedApiResponse,
        PayersListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/payers/list-selected/`,
          method: 'POST',
          body: queryArg.payerFilters,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_multiload: queryArg.canMultiload,
            id: queryArg.id,
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer_settings__allow_only_specific_drivers:
              queryArg.payerSettingsAllowOnlySpecificDrivers,
            payer_settings__allow_only_specific_vehicles:
              queryArg.payerSettingsAllowOnlySpecificVehicles,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payersandtemplatesRetrieve: build.query<
        PayersandtemplatesRetrieveApiResponse,
        PayersandtemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payersandtemplates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      payerstemplatesList: build.query<
        PayerstemplatesListApiResponse,
        PayerstemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/payerstemplates/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['payers'],
      }),
      payerstemplatesRetrieve: build.query<
        PayerstemplatesRetrieveApiResponse,
        PayerstemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/payerstemplates/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['payers'],
      }),
      pricingPriceQuoteCreate: build.mutation<
        PricingPriceQuoteCreateApiResponse,
        PricingPriceQuoteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/price-quote/`,
          method: 'POST',
          body: queryArg.priceQuoteWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemeConflictsCreate: build.mutation<
        PricingPricingSchemeConflictsCreateApiResponse,
        PricingPricingSchemeConflictsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-scheme-conflicts/`,
          method: 'POST',
          body: queryArg.priceSchemeConflict,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesList: build.query<
        PricingPricingSchemesListApiResponse,
        PricingPricingSchemesListApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payer__in: queryArg.payerIn,
            pricing_scheme_payers__payer_id:
              queryArg.pricingSchemePayersPayerId,
            search: queryArg.search,
            service_type__in: queryArg.serviceTypeIn,
            space_type__in: queryArg.spaceTypeIn,
          },
        }),
        providesTags: ['pricing'],
      }),
      pricingPricingSchemesCreate: build.mutation<
        PricingPricingSchemesCreateApiResponse,
        PricingPricingSchemesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/`,
          method: 'POST',
          body: queryArg.pricingSchemeWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesDestroy: build.mutation<
        PricingPricingSchemesDestroyApiResponse,
        PricingPricingSchemesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['pricing'],
      }),
      pricingPricingSchemesRetrieve: build.query<
        PricingPricingSchemesRetrieveApiResponse,
        PricingPricingSchemesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['pricing'],
      }),
      pricingPricingSchemesPartialUpdate: build.mutation<
        PricingPricingSchemesPartialUpdateApiResponse,
        PricingPricingSchemesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/pricing/pricing-schemes/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedPricingSchemeWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['pricing'],
      }),
      profileRetrieve: build.query<
        ProfileRetrieveApiResponse,
        ProfileRetrieveApiArg
      >({
        query: () => ({ url: `/profile/` }),
        providesTags: ['user'],
      }),
      reportsCustomReportsList: build.query<
        ReportsCustomReportsListApiResponse,
        ReportsCustomReportsListApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['reports'],
      }),
      reportsCustomReportsCreate: build.mutation<
        ReportsCustomReportsCreateApiResponse,
        ReportsCustomReportsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports`,
          method: 'POST',
          body: queryArg.customReportWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsCustomReportsDestroy: build.mutation<
        ReportsCustomReportsDestroyApiResponse,
        ReportsCustomReportsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsCustomReportsRetrieve: build.query<
        ReportsCustomReportsRetrieveApiResponse,
        ReportsCustomReportsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['reports'],
      }),
      reportsCustomReportsPartialUpdate: build.mutation<
        ReportsCustomReportsPartialUpdateApiResponse,
        ReportsCustomReportsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/custom-reports/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedCustomReportWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['reports'],
      }),
      reportsTripsLoadedMileageCountCreate: build.query<
        ReportsTripsLoadedMileageCountCreateApiResponse,
        ReportsTripsLoadedMileageCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/loaded-mileage-count/`,
          method: 'POST',
          body: queryArg.tripLoadedMileageRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsOnTimeCountCreate: build.query<
        ReportsTripsOnTimeCountCreateApiResponse,
        ReportsTripsOnTimeCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/on-time-count/`,
          method: 'POST',
          body: queryArg.tripOnTimeRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsRevenueCountCreate: build.query<
        ReportsTripsRevenueCountCreateApiResponse,
        ReportsTripsRevenueCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/revenue-count/`,
          method: 'POST',
          body: queryArg.tripRevenueRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['reports'],
      }),
      reportsTripsStatusCountCreate: build.query<
        ReportsTripsStatusCountCreateApiResponse,
        ReportsTripsStatusCountCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/reports/trips/status-count/`,
          method: 'POST',
          body: queryArg.tripStatusCountRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['reports'],
      }),
      runBambiRunCreate: build.mutation<
        RunBambiRunCreateApiResponse,
        RunBambiRunCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/`,
          method: 'POST',
          body: queryArg.runBambiRun,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['run-bambi-run'],
      }),
      runBambiRunRetrieve: build.query<
        RunBambiRunRetrieveApiResponse,
        RunBambiRunRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['run-bambi-run'],
      }),
      runBambiRunApplyCreate: build.mutation<
        RunBambiRunApplyCreateApiResponse,
        RunBambiRunApplyCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/run-bambi-run/${queryArg.id}/apply/`,
          method: 'POST',
          body: queryArg.runBambiRunApply,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['run-bambi-run'],
      }),
      signaturesList: build.query<
        SignaturesListApiResponse,
        SignaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['signatures'],
      }),
      signaturesCreate: build.mutation<
        SignaturesCreateApiResponse,
        SignaturesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/`,
          method: 'POST',
          body: queryArg.signatureWritable,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['signatures'],
      }),
      signaturesDestroy: build.mutation<
        SignaturesDestroyApiResponse,
        SignaturesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        invalidatesTags: ['signatures'],
      }),
      signaturesRetrieve: build.query<
        SignaturesRetrieveApiResponse,
        SignaturesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/signatures/${queryArg.id}/`,
          headers: {
            ...(queryArg.deviceRequestedAt !== undefined && {
              'Device-Requested-At': queryArg.deviceRequestedAt,
            }),
            ...(queryArg.heading !== undefined && {
              Heading: queryArg.heading,
            }),
            ...(queryArg.latitude !== undefined && {
              Latitude: queryArg.latitude,
            }),
            ...(queryArg.locationAccuracy !== undefined && {
              'Location-Accuracy': queryArg.locationAccuracy,
            }),
            ...(queryArg.locationQueriedAt !== undefined && {
              'Location-Queried-At': queryArg.locationQueriedAt,
            }),
            ...(queryArg.longitude !== undefined && {
              Longitude: queryArg.longitude,
            }),
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            ...(queryArg.speed !== undefined && { Speed: queryArg.speed }),
          },
        }),
        providesTags: ['signatures'],
      }),
      tagsList: build.query<TagsListApiResponse, TagsListApiArg>({
        query: (queryArg) => ({
          url: `/tags/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      tagsCreate: build.mutation<TagsCreateApiResponse, TagsCreateApiArg>({
        query: (queryArg) => ({
          url: `/tags/`,
          method: 'POST',
          body: queryArg.tagWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tags'],
      }),
      tagsDestroy: build.mutation<TagsDestroyApiResponse, TagsDestroyApiArg>({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tags'],
      }),
      tagsRetrieve: build.query<TagsRetrieveApiResponse, TagsRetrieveApiArg>({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tags'],
      }),
      tagsPartialUpdate: build.mutation<
        TagsPartialUpdateApiResponse,
        TagsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/tags/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTagWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tags'],
      }),
      tilledPaymentMethodDestroy: build.mutation<
        TilledPaymentMethodDestroyApiResponse,
        TilledPaymentMethodDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { payment_method_id: queryArg.paymentMethodId },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodRetrieve: build.query<
        TilledPaymentMethodRetrieveApiResponse,
        TilledPaymentMethodRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            payer_id: queryArg.payerId,
            payer_type: queryArg.payerType,
          },
        }),
        providesTags: ['tilled'],
      }),
      tilledPaymentMethodCreate: build.mutation<
        TilledPaymentMethodCreateApiResponse,
        TilledPaymentMethodCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/`,
          method: 'POST',
          body: queryArg.tilledPaymentMethodInput,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodPartialUpdate: build.mutation<
        TilledPaymentMethodPartialUpdateApiResponse,
        TilledPaymentMethodPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/`,
          method: 'PATCH',
          body: queryArg.patchedTilledPaymentMethodBillingDetails,
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPaymentMethodVerifyRetrieve: build.query<
        TilledPaymentMethodVerifyRetrieveApiResponse,
        TilledPaymentMethodVerifyRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/verify/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tilled'],
      }),
      tilledPaymentMethodVerifyCreate: build.mutation<
        TilledPaymentMethodVerifyCreateApiResponse,
        TilledPaymentMethodVerifyCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payment-method/${queryArg.paymentMethodId}/verify/`,
          method: 'POST',
          body: queryArg.tilledPaymentMethodVerifyRequest,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledPayoutsList: build.query<
        TilledPayoutsListApiResponse,
        TilledPayoutsListApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payouts/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            invoice_number: queryArg.invoiceNumber,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            paid_at_after: queryArg.paidAtAfter,
            paid_at_before: queryArg.paidAtBefore,
            selected_invoices: queryArg.selectedInvoices,
          },
        }),
        providesTags: ['tilled'],
      }),
      tilledPayoutsExportCreate: build.query<
        TilledPayoutsExportCreateApiResponse,
        TilledPayoutsExportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/payouts/export/`,
          method: 'POST',
          body: queryArg.invoicesListFilter,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            invoice_number: queryArg.invoiceNumber,
            paid_at_after: queryArg.paidAtAfter,
            paid_at_before: queryArg.paidAtBefore,
            selected_invoices: queryArg.selectedInvoices,
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      tilledResourceLinkCreate: build.mutation<
        TilledResourceLinkCreateApiResponse,
        TilledResourceLinkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/resource-link/`,
          method: 'POST',
          body: queryArg.tilledResourceLink,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tilled'],
      }),
      tilledWebhookCreate: build.mutation<
        TilledWebhookCreateApiResponse,
        TilledWebhookCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tilled/webhook/`,
          method: 'POST',
          body: queryArg.tilledWebHookEnvelope,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['tilled'],
      }),
      tokensChatIssueRetrieve: build.query<
        TokensChatIssueRetrieveApiResponse,
        TokensChatIssueRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/chat/issue/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['members'],
      }),
      tokensPushRegisterCreate: build.mutation<
        TokensPushRegisterCreateApiResponse,
        TokensPushRegisterCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/push/register/`,
          method: 'POST',
          body: queryArg.pushTokensWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            'User-Agent': queryArg.userAgent,
          },
        }),
        invalidatesTags: ['members'],
      }),
      tokensPushRevokeCreate: build.mutation<
        TokensPushRevokeCreateApiResponse,
        TokensPushRevokeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/tokens/push/revoke/`,
          method: 'POST',
          body: queryArg.pushTokensWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
            'User-Agent': queryArg.userAgent,
          },
        }),
        invalidatesTags: ['members'],
      }),
      tripImportCreate: build.mutation<
        TripImportCreateApiResponse,
        TripImportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-import/`,
          method: 'POST',
          body: queryArg.tripImportAsyncRequestWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trip-import'],
      }),
      tripImportRetrieve: build.query<
        TripImportRetrieveApiResponse,
        TripImportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-import/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trip-import'],
      }),
      tripRequestEmbedList: build.query<
        TripRequestEmbedListApiResponse,
        TripRequestEmbedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            is_active: queryArg.isActive,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedCreate: build.mutation<
        TripRequestEmbedCreateApiResponse,
        TripRequestEmbedCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/`,
          method: 'POST',
          body: queryArg.tripRequestEmbedWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedDestroy: build.mutation<
        TripRequestEmbedDestroyApiResponse,
        TripRequestEmbedDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedRetrieve: build.query<
        TripRequestEmbedRetrieveApiResponse,
        TripRequestEmbedRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['trip-request-embed'],
      }),
      tripRequestEmbedPartialUpdate: build.mutation<
        TripRequestEmbedPartialUpdateApiResponse,
        TripRequestEmbedPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-request-embed/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTripRequestEmbedWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['trip-request-embed'],
      }),
      tripTagsList: build.query<TripTagsListApiResponse, TripTagsListApiArg>({
        query: (queryArg) => ({
          url: `/trip-tags/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['tags'],
      }),
      tripTagsCreate: build.mutation<
        TripTagsCreateApiResponse,
        TripTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/`,
          method: 'POST',
          body: queryArg.tripTagBulkCreateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'trips', 'tags'],
      }),
      tripTagsDestroy: build.mutation<
        TripTagsDestroyApiResponse,
        TripTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'trips', 'tags'],
      }),
      tripTagsRetrieve: build.query<
        TripTagsRetrieveApiResponse,
        TripTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trip-tags/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tags'],
      }),
      vehicleTagsList: build.query<
        VehicleTagsListApiResponse,
        VehicleTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['vehicles', 'tags'],
      }),
      vehicleTagsCreate: build.mutation<
        VehicleTagsCreateApiResponse,
        VehicleTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/`,
          method: 'POST',
          body: queryArg.vehicleTagBulkCreateWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
      }),
      vehicleTagsDestroy: build.mutation<
        VehicleTagsDestroyApiResponse,
        VehicleTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
      }),
      vehicleTagsRetrieve: build.query<
        VehicleTagsRetrieveApiResponse,
        VehicleTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicle-tags/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['tags'],
      }),
      vehiclesList: build.query<VehiclesListApiResponse, VehiclesListApiArg>({
        query: (queryArg) => ({
          url: `/vehicles/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesCreate: build.mutation<
        VehiclesCreateApiResponse,
        VehiclesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/`,
          method: 'POST',
          body: queryArg.vehicleWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesDestroy: build.mutation<
        VehiclesDestroyApiResponse,
        VehiclesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          method: 'DELETE',
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesRetrieve: build.query<
        VehiclesRetrieveApiResponse,
        VehiclesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesPartialUpdate: build.mutation<
        VehiclesPartialUpdateApiResponse,
        VehiclesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedVehicleWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { deleted_objects: queryArg.deletedObjects },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesPayersList: build.query<
        VehiclesPayersListApiResponse,
        VehiclesPayersListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.vehicleId}/payers/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesPayersCreate: build.mutation<
        VehiclesPayersCreateApiResponse,
        VehiclesPayersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/${queryArg.vehicleId}/payers/`,
          method: 'POST',
          body: queryArg.vehiclePayerOrganization,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesInspectionCreate: build.mutation<
        VehiclesInspectionCreateApiResponse,
        VehiclesInspectionCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspection/`,
          method: 'POST',
          body: queryArg.vehicleInspectionReportWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['vehicles'],
      }),
      vehiclesInspectionFieldsList: build.query<
        VehiclesInspectionFieldsListApiResponse,
        VehiclesInspectionFieldsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspection-fields/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsList: build.query<
        VehiclesInspectionsListApiResponse,
        VehiclesInspectionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assignment: queryArg.assignment,
            created_at: queryArg.createdAt,
            has_fail: queryArg.hasFail,
            membership: queryArg.membership,
            membership__in: queryArg.membershipIn,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            vehicle: queryArg.vehicle,
            vehicle__in: queryArg.vehicleIn,
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsRetrieve: build.query<
        VehiclesInspectionsRetrieveApiResponse,
        VehiclesInspectionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/${queryArg.id}/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        providesTags: ['vehicles'],
      }),
      vehiclesInspectionsExportRetrieve: build.query<
        VehiclesInspectionsExportRetrieveApiResponse,
        VehiclesInspectionsExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/inspections/export/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            assignment: queryArg.assignment,
            created_at: queryArg.createdAt,
            has_fail: queryArg.hasFail,
            membership: queryArg.membership,
            membership__in: queryArg.membershipIn,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            vehicle: queryArg.vehicle,
            vehicle__in: queryArg.vehicleIn,
          },
          responseHandler: fileResponseHandler,
        }),
        keepUnusedDataFor: 0,
      }),
      vehiclesListSelected: build.query<
        VehiclesListSelectedApiResponse,
        VehiclesListSelectedApiArg
      >({
        query: (queryArg) => ({
          url: `/vehicles/list-selected/`,
          method: 'POST',
          body: queryArg.vehicleFilters,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: {
            can_be_scheduled: queryArg.canBeScheduled,
            deleted_objects: queryArg.deletedObjects,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
          },
        }),
        providesTags: ['vehicles'],
      }),
      webPushSubscriptionList: build.query<
        WebPushSubscriptionListApiResponse,
        WebPushSubscriptionListApiArg
      >({
        query: (queryArg) => ({
          url: `/web-push-subscription/`,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['device'],
      }),
      webPushSubscriptionCreate: build.mutation<
        WebPushSubscriptionCreateApiResponse,
        WebPushSubscriptionCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/web-push-subscription/`,
          method: 'POST',
          body: queryArg.webPushSubscriptionWritable,
          headers: {
            ...(queryArg.organizationId !== undefined && {
              'Organization-ID': queryArg.organizationId,
            }),
          },
        }),
        invalidatesTags: ['device'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useAttendantsListQuery,
  useLazyAttendantsListQuery,
  useAttendantsCreateMutation,
  useAttendantsDestroyMutation,
  useAttendantsRetrieveQuery,
  useLazyAttendantsRetrieveQuery,
  useAttendantsPartialUpdateMutation,
  useAttendantsSkillsCreateMutation,
  useAttendantsSkillsDestroyMutation,
  useAttendantsSkillsRetrieveQuery,
  useLazyAttendantsSkillsRetrieveQuery,
  useAttendantsSkillsPartialUpdateMutation,
  useAttendantsSkillsUpdateMutation,
  useBillingBillingSettingsRetrieveQuery,
  useLazyBillingBillingSettingsRetrieveQuery,
  useBillingBillingSettingsPartialUpdateMutation,
  useBillingBillingSettingsNextInvoiceNumberRetrieveQuery,
  useLazyBillingBillingSettingsNextInvoiceNumberRetrieveQuery,
  useBillingTripsBillingListQuery,
  useLazyBillingTripsBillingListQuery,
  useBrokersAliviAdminListQuery,
  useLazyBrokersAliviAdminListQuery,
  useBrokersAliviAdminCreateMutation,
  useBrokersAliviOauth2TokenCreateMutation,
  useBrokersAliviRideActivateWillcallCreateMutation,
  useBrokersAliviRideCancelCreateMutation,
  useBrokersAliviRideCancelWillcallActivationCreateMutation,
  useBrokersAliviRideGetStatusCreateMutation,
  useBrokersAliviRideOfferCreateMutation,
  useBrokersAliviRideUpdateCreateMutation,
  useBrokersClearviewOauth2TokenCreateMutation,
  useBrokersClearviewTransportPayerListQuery,
  useLazyBrokersClearviewTransportPayerListQuery,
  useBrokersClearviewTransportPayerCreateMutation,
  useBrokersClearviewTransportProviderListQuery,
  useLazyBrokersClearviewTransportProviderListQuery,
  useBrokersClearviewTransportProviderCreateMutation,
  useBrokersClearviewTripsListQuery,
  useLazyBrokersClearviewTripsListQuery,
  useBrokersClearviewTripsCreateMutation,
  useBrokersClearviewTripsRetrieveQuery,
  useLazyBrokersClearviewTripsRetrieveQuery,
  useBrokersClearviewTripsPartialUpdateMutation,
  useBrokersClearviewTripsCancelCreateMutation,
  useBrokersCtcOauth2TokenCreateMutation,
  useBrokersCtcTripCreateMutation,
  useBrokersCtcTripRetrieveQuery,
  useLazyBrokersCtcTripRetrieveQuery,
  useBrokersCtcTripActivationCreateMutation,
  useBrokersCtcTripCancelCreateMutation,
  useBrokersCtcTripsListQuery,
  useLazyBrokersCtcTripsListQuery,
  useBrokersExampleHelloWorldRetrieveQuery,
  useLazyBrokersExampleHelloWorldRetrieveQuery,
  useBrokersKinetikAdminListQuery,
  useLazyBrokersKinetikAdminListQuery,
  useBrokersKinetikAdminCreateMutation,
  useBrokersKinetikOauth2TokenCreateMutation,
  useBrokersKinetikV1CancelRideCreateMutation,
  useBrokersKinetikV1CreateRidesCreateMutation,
  useBrokersKinetikV1GetDriverCreateMutation,
  useBrokersKinetikV1GetRideCreateMutation,
  useBrokersKinetikV1GetVehicleCreateMutation,
  useBrokersKinetikV1UpdateRidesUpdateMutation,
  useBrokersLogsSearchRetrieveQuery,
  useLazyBrokersLogsSearchRetrieveQuery,
  useBrokersMedidriveWebhooksCreateMutation,
  useBrokersModivcareRideCreateMutation,
  useBrokersModivcareRideUpdateMutation,
  useBrokersModivcareRideCancelCreateMutation,
  useBrokersModivcareRideEventsRetrieveQuery,
  useLazyBrokersModivcareRideEventsRetrieveQuery,
  useBrokersModivcareAdminListQuery,
  useLazyBrokersModivcareAdminListQuery,
  useBrokersModivcareAdminCreateMutation,
  useBrokersModivcareAdminBackfillCreateMutation,
  useBrokersModivcareAdminBillableTripsListQuery,
  useLazyBrokersModivcareAdminBillableTripsListQuery,
  useBrokersModivcareAdminDriversListQuery,
  useLazyBrokersModivcareAdminDriversListQuery,
  useBrokersModivcareAdminRideReceiptCreateMutation,
  useBrokersModivcareOauth2TokenCreateMutation,
  useBrokersMomentmBrokerAuthListQuery,
  useLazyBrokersMomentmBrokerAuthListQuery,
  useBrokersMomentmBrokerAuthCreateMutation,
  useBrokersMomentmBrokerAuthDestroyMutation,
  useBrokersMomentmBrokerAuthRetrieveQuery,
  useLazyBrokersMomentmBrokerAuthRetrieveQuery,
  useBrokersMomentmBrokerAuthPartialUpdateMutation,
  useBrokersMomentmBrokerAuthUpdateMutation,
  useBrokersMomentmBrokerAuthSetSecretCreateMutation,
  useBrokersMomentmSetSecretCreateMutation,
  useBrokersMoviWebhookCreateMutation,
  useBrokersMtmInitCreateMutation,
  useBrokersMtmOauth2TokenCreateMutation,
  useBrokersMtmSetSecretCreateMutation,
  useBrokersMtmTransportationProvidersListQuery,
  useLazyBrokersMtmTransportationProvidersListQuery,
  useBrokersMtmTransportationProvidersCreateMutation,
  useBrokersMtmTransportationProvidersDestroyMutation,
  useBrokersMtmTransportationProvidersRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersRetrieveQuery,
  useBrokersMtmTransportationProvidersPartialUpdateMutation,
  useBrokersMtmTransportationProvidersUpdateMutation,
  useBrokersMtmTransportationProvidersBackfillTripsCreateMutation,
  useBrokersMtmTransportationProvidersGetEmailRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersGetEmailRetrieveQuery,
  useBrokersMtmTransportationProvidersTurnbackReasonsRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersTurnbackReasonsRetrieveQuery,
  useBrokersMtmTransportationProvidersBackfillRunsListQuery,
  useLazyBrokersMtmTransportationProvidersBackfillRunsListQuery,
  useBrokersMtmTransportationProvidersGetEmailTextRetrieveQuery,
  useLazyBrokersMtmTransportationProvidersGetEmailTextRetrieveQuery,
  useBrokersMtmTransportationProvidersInitCreateMutation,
  useBrokersMtmTransportationProvidersSetSecretCreateMutation,
  useBrokersMtmWebhookCreateMutation,
  useBrokersProvideARideOauth2TokenCreateMutation,
  useBrokersProvideARideTripsCreateMutation,
  useBrokersProvideARideTripsRetrieveQuery,
  useLazyBrokersProvideARideTripsRetrieveQuery,
  useBrokersProvideARideTripsCancelCreateMutation,
  useBrokersVectorcareWebhookCreateMutation,
  useBrokersVeridaClaimsListQuery,
  useLazyBrokersVeridaClaimsListQuery,
  useBrokersVeridaClaimsRetryCreateMutation,
  useCredentialsListQuery,
  useLazyCredentialsListQuery,
  useCredentialsCreateMutation,
  useCredentialsDestroyMutation,
  useCredentialsRetrieveQuery,
  useLazyCredentialsRetrieveQuery,
  useCredentialsPartialUpdateMutation,
  useCredentialsExpiringSoonCountRetrieveQuery,
  useLazyCredentialsExpiringSoonCountRetrieveQuery,
  useCredentialsTypesListQuery,
  useLazyCredentialsTypesListQuery,
  useCredentialsTypesCreateMutation,
  useCredentialsTypesDestroyMutation,
  useCredentialsTypesRetrieveQuery,
  useLazyCredentialsTypesRetrieveQuery,
  useCredentialsTypesPartialUpdateMutation,
  useDailyDigestCreateMutation,
  useDieCreateMutation,
  useDispatchRetrieveQuery,
  useLazyDispatchRetrieveQuery,
  useDispatchAssignedRetrieveQuery,
  useLazyDispatchAssignedRetrieveQuery,
  useDispatchSummaryRetrieveQuery,
  useLazyDispatchSummaryRetrieveQuery,
  useDispatchUnassignedRetrieveQuery,
  useLazyDispatchUnassignedRetrieveQuery,
  useDriverTagsListQuery,
  useLazyDriverTagsListQuery,
  useDriverTagsCreateMutation,
  useDriverTagsDestroyMutation,
  useDriverTagsRetrieveQuery,
  useLazyDriverTagsRetrieveQuery,
  useDriversListQuery,
  useLazyDriversListQuery,
  useDriversCreateMutation,
  useDriversPayersListQuery,
  useLazyDriversPayersListQuery,
  useDriversPayersCreateMutation,
  useDriversDestroyMutation,
  useDriversRetrieveQuery,
  useLazyDriversRetrieveQuery,
  useDriversPartialUpdateMutation,
  useDriversUndeleteCreateMutation,
  useDriversListSelectedQuery,
  useLazyDriversListSelectedQuery,
  useFilesImportFileListQuery,
  useLazyFilesImportFileListQuery,
  useFilesImportFileCreateMutation,
  useFilterGroupsListQuery,
  useLazyFilterGroupsListQuery,
  useFilterGroupsCreateMutation,
  useFilterGroupsDestroyMutation,
  useFilterGroupsRetrieveQuery,
  useLazyFilterGroupsRetrieveQuery,
  useFilterGroupsPartialUpdateMutation,
  useFilterGroupsCreateExamplesCreateMutation,
  useFlagsFeatureValuesListQuery,
  useLazyFlagsFeatureValuesListQuery,
  useFlagsFeatureValuesMobileListQuery,
  useLazyFlagsFeatureValuesMobileListQuery,
  useFlagsFeatureValuesWebListQuery,
  useLazyFlagsFeatureValuesWebListQuery,
  useFlagsFeaturesListQuery,
  useLazyFlagsFeaturesListQuery,
  useInternalE2eFactoryRunsCreateMutation,
  useInternalE2eFactoryRunsCleanupCreateMutation,
  useInvoicesPayersListQuery,
  useLazyInvoicesPayersListQuery,
  useInvoicesTripsListQuery,
  useLazyInvoicesTripsListQuery,
  useInvoicesExportRetrieveQuery,
  useLazyInvoicesExportRetrieveQuery,
  useInvoicesExportInvoiceEmailsRetrieveQuery,
  useLazyInvoicesExportInvoiceEmailsRetrieveQuery,
  useInvoicesExportPaymentsRetrieveQuery,
  useLazyInvoicesExportPaymentsRetrieveQuery,
  useInvoicePaymentsListSelectedQuery,
  useLazyInvoicePaymentsListSelectedQuery,
  useInvoicesExportRefundsRetrieveQuery,
  useLazyInvoicesExportRefundsRetrieveQuery,
  useInvoiceRefundsListSelectedQuery,
  useLazyInvoiceRefundsListSelectedQuery,
  useInvoiceLineItemsListSelectedQuery,
  useLazyInvoiceLineItemsListSelectedQuery,
  useInvoicesInvoiceEmailListQuery,
  useLazyInvoicesInvoiceEmailListQuery,
  useInvoicesInvoiceEmailCreateMutation,
  useInvoicesInvoicesListQuery,
  useLazyInvoicesInvoicesListQuery,
  useInvoicesInvoicesCreateMutation,
  useInvoicesInvoicesDestroyMutation,
  useInvoicesInvoicesRetrieveQuery,
  useLazyInvoicesInvoicesRetrieveQuery,
  useInvoicesInvoicesPartialUpdateMutation,
  useInvoicesLineItemsListQuery,
  useLazyInvoicesLineItemsListQuery,
  useInvoicesLineItemsCreateMutation,
  useInvoicesLineItemsDestroyMutation,
  useInvoicesLineItemsRetrieveQuery,
  useLazyInvoicesLineItemsRetrieveQuery,
  useInvoicesLineItemsPartialUpdateMutation,
  useInvoicesPaymentLinkListQuery,
  useLazyInvoicesPaymentLinkListQuery,
  useInvoicesPaymentLinkCreateMutation,
  useInvoicesPaymentLinkEmailCreateMutation,
  useInvoicesPaymentLinkRetrieveQuery,
  useLazyInvoicesPaymentLinkRetrieveQuery,
  useInvoicesPaymentLinkPartialUpdateMutation,
  useInvoicesPaymentsListQuery,
  useLazyInvoicesPaymentsListQuery,
  useInvoicesPaymentsCreateMutation,
  useInvoicesPaymentsRetrieveQuery,
  useLazyInvoicesPaymentsRetrieveQuery,
  useInvoicesRefundsListQuery,
  useLazyInvoicesRefundsListQuery,
  useInvoicesRefundsCreateMutation,
  useInvoicesRefundsRetrieveQuery,
  useLazyInvoicesRefundsRetrieveQuery,
  useInvoicesTripFinderListQuery,
  useLazyInvoicesTripFinderListQuery,
  useInvoicesTripFinderRetrieveQuery,
  useLazyInvoicesTripFinderRetrieveQuery,
  useItineraryRetrieveQuery,
  useLazyItineraryRetrieveQuery,
  useItineraryLatenessListQuery,
  useLazyItineraryLatenessListQuery,
  useItineraryLatenessDetailQuery,
  useLazyItineraryLatenessDetailQuery,
  useAssignmentTripLatenessQuery,
  useLazyAssignmentTripLatenessQuery,
  useLocationsAddressesListQuery,
  useLazyLocationsAddressesListQuery,
  useLocationsAddressesRetrieveQuery,
  useLazyLocationsAddressesRetrieveQuery,
  useLocationsCountiesListQuery,
  useLazyLocationsCountiesListQuery,
  useLocationsGeolocationsListQuery,
  useLazyLocationsGeolocationsListQuery,
  useLocationsGeolocationsCreateMutation,
  useLocationsGeolocationsDestroyMutation,
  useLocationsGeolocationsRetrieveQuery,
  useLazyLocationsGeolocationsRetrieveQuery,
  useLocationsGeolocationsPartialUpdateMutation,
  useLocationsGeolocationsUndeleteCreateMutation,
  useLocationsLocationLogEntryTripsListQuery,
  useLazyLocationsLocationLogEntryTripsListQuery,
  useLocationsLogCreateMutation,
  useLocationsMunicipalitiesRetrieveQuery,
  useLazyLocationsMunicipalitiesRetrieveQuery,
  useLocationsPassengerAddressesListQuery,
  useLazyLocationsPassengerAddressesListQuery,
  useLocationsPassengerAddressesCreateMutation,
  useLocationsPassengerAddressesDestroyMutation,
  useLocationsPassengerAddressesRetrieveQuery,
  useLazyLocationsPassengerAddressesRetrieveQuery,
  useLocationsPassengerAddressesPartialUpdateMutation,
  useLocationsPassengerAddressesUpdateMutation,
  useLocationsZipcodesListQuery,
  useLazyLocationsZipcodesListQuery,
  useMembersListQuery,
  useLazyMembersListQuery,
  useMembersCreateMutation,
  useMembersDestroyMutation,
  useMembersRetrieveQuery,
  useLazyMembersRetrieveQuery,
  useMembersPartialUpdateMutation,
  useMembersUndeleteCreateMutation,
  useMembersUpdateEmailCreateMutation,
  useMessagesListQuery,
  useLazyMessagesListQuery,
  useMessagesCreateMutation,
  useMessagesRetrieveQuery,
  useLazyMessagesRetrieveQuery,
  useMessagesTripMessagesListQuery,
  useLazyMessagesTripMessagesListQuery,
  useMessagesTripMessagesCreateMutation,
  useMessagesTripMessagesRetrieveQuery,
  useLazyMessagesTripMessagesRetrieveQuery,
  useMessagesWebHookMessageUpdateCreateMutation,
  useMobileAppSettingsRetrieveQuery,
  useLazyMobileAppSettingsRetrieveQuery,
  useMobileAppSettingsPartialUpdateMutation,
  useNotificationsAllNotificationsListQuery,
  useLazyNotificationsAllNotificationsListQuery,
  useNotificationsAllNotificationsRetrieveQuery,
  useLazyNotificationsAllNotificationsRetrieveQuery,
  useNotificationsAudiencesListQuery,
  useLazyNotificationsAudiencesListQuery,
  useNotificationsAudiencesRetrieveQuery,
  useLazyNotificationsAudiencesRetrieveQuery,
  useNotificationsChannelsListQuery,
  useLazyNotificationsChannelsListQuery,
  useNotificationsChannelsRetrieveQuery,
  useLazyNotificationsChannelsRetrieveQuery,
  useNotificationsMemberSettingsListQuery,
  useLazyNotificationsMemberSettingsListQuery,
  useNotificationsMemberSettingsCreateMutation,
  useNotificationsMemberSettingsRetrieveQuery,
  useLazyNotificationsMemberSettingsRetrieveQuery,
  useNotificationsMemberSettingsPartialUpdateMutation,
  useNotificationsNotificationsListQuery,
  useLazyNotificationsNotificationsListQuery,
  useNotificationsNotificationsRetrieveQuery,
  useLazyNotificationsNotificationsRetrieveQuery,
  useNotificationsNotificationsPartialUpdateMutation,
  useNotificationsNotificationsCountRetrieveQuery,
  useLazyNotificationsNotificationsCountRetrieveQuery,
  useNotificationsNotificationsMarkAllReadPartialUpdateMutation,
  useNotificationsNotificationsMarkAllSeenPartialUpdateMutation,
  useNotificationsRoleSettingsListQuery,
  useLazyNotificationsRoleSettingsListQuery,
  useNotificationsRoleSettingsCreateMutation,
  useNotificationsRoleSettingsRetrieveQuery,
  useLazyNotificationsRoleSettingsRetrieveQuery,
  useNotificationsRoleSettingsPartialUpdateMutation,
  useOrganizationBillingStatusRetrieveQuery,
  useLazyOrganizationBillingStatusRetrieveQuery,
  useOrganizationInternalSettingsPartialUpdateMutation,
  useOrganizationSettingsRetrieveQuery,
  useLazyOrganizationSettingsRetrieveQuery,
  useOrganizationSettingsPartialUpdateMutation,
  useOrganizationSettingsConnectMerchantAccountCreateMutation,
  useOrganizationSettingsLogoRetrieveQuery,
  useLazyOrganizationSettingsLogoRetrieveQuery,
  usePassengerImportCreateMutation,
  usePassengerImportRetrieveQuery,
  useLazyPassengerImportRetrieveQuery,
  usePassengerTagsListQuery,
  useLazyPassengerTagsListQuery,
  usePassengerTagsCreateMutation,
  usePassengerTagsDestroyMutation,
  usePassengerTagsRetrieveQuery,
  useLazyPassengerTagsRetrieveQuery,
  usePassengersListQuery,
  useLazyPassengersListQuery,
  usePassengersCreateMutation,
  usePassengersAlternateIdentifiersListQuery,
  useLazyPassengersAlternateIdentifiersListQuery,
  usePassengersAlternateIdentifiersCreateMutation,
  usePassengersAlternateIdentifiersDestroyMutation,
  usePassengersAlternateIdentifiersRetrieveQuery,
  useLazyPassengersAlternateIdentifiersRetrieveQuery,
  usePassengersAlternateIdentifiersPartialUpdateMutation,
  usePassengersPreferredDriversListQuery,
  useLazyPassengersPreferredDriversListQuery,
  usePassengersPreferredDriversCreateMutation,
  usePassengersPreferredDriversDestroyMutation,
  usePassengersPreferredDriversRetrieveQuery,
  useLazyPassengersPreferredDriversRetrieveQuery,
  usePassengersPreferredDriversPartialUpdateMutation,
  usePassengersDestroyMutation,
  usePassengersRetrieveQuery,
  useLazyPassengersRetrieveQuery,
  usePassengersPartialUpdateMutation,
  usePassengersRecentAddressesListQuery,
  useLazyPassengersRecentAddressesListQuery,
  usePassengersRecentPayersListQuery,
  useLazyPassengersRecentPayersListQuery,
  usePassengersUndeleteCreateMutation,
  usePassengersDuplicatesListQuery,
  useLazyPassengersDuplicatesListQuery,
  usePassengersExportRetrieveQuery,
  useLazyPassengersExportRetrieveQuery,
  usePassengersMergeCreateMutation,
  usePayerInfoImportTemplateListQuery,
  useLazyPayerInfoImportTemplateListQuery,
  usePayerSettingsListQuery,
  useLazyPayerSettingsListQuery,
  usePayerSettingsRetrieveQuery,
  useLazyPayerSettingsRetrieveQuery,
  usePayerSettingsPartialUpdateMutation,
  usePayerinfoListQuery,
  useLazyPayerinfoListQuery,
  usePayerinfoRetrieveQuery,
  useLazyPayerinfoRetrieveQuery,
  usePayersListQuery,
  useLazyPayersListQuery,
  usePayersCreateMutation,
  usePayersDriversListQuery,
  useLazyPayersDriversListQuery,
  usePayersDriversCreateMutation,
  usePayersPassengersDestroyMutation,
  usePayersPassengersRetrieveQuery,
  useLazyPayersPassengersRetrieveQuery,
  usePayersPassengersPartialUpdateMutation,
  usePayersPassengersCreateMutation,
  usePayersSettingsRetrieveQuery,
  useLazyPayersSettingsRetrieveQuery,
  usePayersSettingsPartialUpdateMutation,
  usePayersVehiclesListQuery,
  useLazyPayersVehiclesListQuery,
  usePayersVehiclesCreateMutation,
  usePayersDestroyMutation,
  usePayersRetrieveQuery,
  useLazyPayersRetrieveQuery,
  usePayersPartialUpdateMutation,
  usePayersMultiloadingPartnersRetrieveQuery,
  useLazyPayersMultiloadingPartnersRetrieveQuery,
  usePayersListSelectedQuery,
  useLazyPayersListSelectedQuery,
  usePayersandtemplatesRetrieveQuery,
  useLazyPayersandtemplatesRetrieveQuery,
  usePayerstemplatesListQuery,
  useLazyPayerstemplatesListQuery,
  usePayerstemplatesRetrieveQuery,
  useLazyPayerstemplatesRetrieveQuery,
  usePricingPriceQuoteCreateMutation,
  usePricingPricingSchemeConflictsCreateMutation,
  usePricingPricingSchemesListQuery,
  useLazyPricingPricingSchemesListQuery,
  usePricingPricingSchemesCreateMutation,
  usePricingPricingSchemesDestroyMutation,
  usePricingPricingSchemesRetrieveQuery,
  useLazyPricingPricingSchemesRetrieveQuery,
  usePricingPricingSchemesPartialUpdateMutation,
  useProfileRetrieveQuery,
  useLazyProfileRetrieveQuery,
  useReportsCustomReportsListQuery,
  useLazyReportsCustomReportsListQuery,
  useReportsCustomReportsCreateMutation,
  useReportsCustomReportsDestroyMutation,
  useReportsCustomReportsRetrieveQuery,
  useLazyReportsCustomReportsRetrieveQuery,
  useReportsCustomReportsPartialUpdateMutation,
  useReportsTripsLoadedMileageCountCreateQuery,
  useLazyReportsTripsLoadedMileageCountCreateQuery,
  useReportsTripsOnTimeCountCreateQuery,
  useLazyReportsTripsOnTimeCountCreateQuery,
  useReportsTripsRevenueCountCreateQuery,
  useLazyReportsTripsRevenueCountCreateQuery,
  useReportsTripsStatusCountCreateQuery,
  useLazyReportsTripsStatusCountCreateQuery,
  useRunBambiRunCreateMutation,
  useRunBambiRunRetrieveQuery,
  useLazyRunBambiRunRetrieveQuery,
  useRunBambiRunApplyCreateMutation,
  useSignaturesListQuery,
  useLazySignaturesListQuery,
  useSignaturesCreateMutation,
  useSignaturesDestroyMutation,
  useSignaturesRetrieveQuery,
  useLazySignaturesRetrieveQuery,
  useTagsListQuery,
  useLazyTagsListQuery,
  useTagsCreateMutation,
  useTagsDestroyMutation,
  useTagsRetrieveQuery,
  useLazyTagsRetrieveQuery,
  useTagsPartialUpdateMutation,
  useTilledPaymentMethodDestroyMutation,
  useTilledPaymentMethodRetrieveQuery,
  useLazyTilledPaymentMethodRetrieveQuery,
  useTilledPaymentMethodCreateMutation,
  useTilledPaymentMethodPartialUpdateMutation,
  useTilledPaymentMethodVerifyRetrieveQuery,
  useLazyTilledPaymentMethodVerifyRetrieveQuery,
  useTilledPaymentMethodVerifyCreateMutation,
  useTilledPayoutsListQuery,
  useLazyTilledPayoutsListQuery,
  useTilledPayoutsExportCreateQuery,
  useLazyTilledPayoutsExportCreateQuery,
  useTilledResourceLinkCreateMutation,
  useTilledWebhookCreateMutation,
  useTokensChatIssueRetrieveQuery,
  useLazyTokensChatIssueRetrieveQuery,
  useTokensPushRegisterCreateMutation,
  useTokensPushRevokeCreateMutation,
  useTripImportCreateMutation,
  useTripImportRetrieveQuery,
  useLazyTripImportRetrieveQuery,
  useTripRequestEmbedListQuery,
  useLazyTripRequestEmbedListQuery,
  useTripRequestEmbedCreateMutation,
  useTripRequestEmbedDestroyMutation,
  useTripRequestEmbedRetrieveQuery,
  useLazyTripRequestEmbedRetrieveQuery,
  useTripRequestEmbedPartialUpdateMutation,
  useTripTagsListQuery,
  useLazyTripTagsListQuery,
  useTripTagsCreateMutation,
  useTripTagsDestroyMutation,
  useTripTagsRetrieveQuery,
  useLazyTripTagsRetrieveQuery,
  useVehicleTagsListQuery,
  useLazyVehicleTagsListQuery,
  useVehicleTagsCreateMutation,
  useVehicleTagsDestroyMutation,
  useVehicleTagsRetrieveQuery,
  useLazyVehicleTagsRetrieveQuery,
  useVehiclesListQuery,
  useLazyVehiclesListQuery,
  useVehiclesCreateMutation,
  useVehiclesDestroyMutation,
  useVehiclesRetrieveQuery,
  useLazyVehiclesRetrieveQuery,
  useVehiclesPartialUpdateMutation,
  useVehiclesPayersListQuery,
  useLazyVehiclesPayersListQuery,
  useVehiclesPayersCreateMutation,
  useVehiclesInspectionCreateMutation,
  useVehiclesInspectionFieldsListQuery,
  useLazyVehiclesInspectionFieldsListQuery,
  useVehiclesInspectionsListQuery,
  useLazyVehiclesInspectionsListQuery,
  useVehiclesInspectionsRetrieveQuery,
  useLazyVehiclesInspectionsRetrieveQuery,
  useVehiclesInspectionsExportRetrieveQuery,
  useLazyVehiclesInspectionsExportRetrieveQuery,
  useVehiclesListSelectedQuery,
  useLazyVehiclesListSelectedQuery,
  useWebPushSubscriptionListQuery,
  useLazyWebPushSubscriptionListQuery,
  useWebPushSubscriptionCreateMutation,
} = bambiApi;
